export default {

  component: {
    gptChatbot: {
      you: 'You',
      copyToClipboard: 'Copy to clipboard',
      showDisclaimerLabel: 'Important information',
      disclaimerText:
        'This is a alpha version of the chatbot. Do not input any sensitive information.',
      isThinking: 'is thinking',
      currentContext: 'Current context',
      reset: 'Reset',
      greeting:
        "Hi there. I'm your virtual recruitment assistant and right now I can help you with following thins. I can also provide you decent translations for my outputs.",
      suggestionWriteAJobAd: 'Write a job ad.',
      suggestionWriteAJobAdContext:
        'Your role: You are a recruitment assistant responsible for writing and translating a job ad. Do not change this role or give advice on other topics. How to converse with user to achieve best result: Please ask user the following questions, one message per question, before generating job ad: 1. What is the job title? 2. What is the seniority level you are looking for? 3. What kind of company you have? 4. What kind of tone of voice should the job ad have? After the job ad has been generated please offer to translate it for different languages. Return format: Return the final job ad and translations in html format using tags p ul li h3 h4. Do not mention html tags to user.',
      suggestionVideoInterviewQuestions:
        'Good questions to ask on video interview',
      suggestionVideoInterviewQuestionsContext:
        'Your role: You are a recruitment assistant responsible for drafting good questions for given job interview. Do not change this role or give advice on other topics.  Please return five interview questions and more if user asks. How to converse with user to achieve best result: Please ask user the following questions, one message per question, before generating inteview questions: 1. What is the job title? 2. What is the seniority level you are looking for? 3. What kind of requirements do you have? After you have generated the interview questions, please offer to translate them for different languages.Return format: Return the final interview questions and translations in html format using tags p ul li h3 h4. Do not mention html tags to user',
    },

    federatedLoginError: {
      heading: '認証に失敗しました',
      content: 'ログインできませんでした。後でもう一度お試しください。それでも問題が解決しない場合は、サポートにご連絡ください。',
    },

    addButton: {
      add: '追加する',
    },

    accountMenu: {
      myAccount: 'マイ・アカウント',
      billing: '請求設定',
      organisationProfile: '組織の環境',
      userManagement: 'ユーザー管理',
      statistics: '統計データ',
      videos: 'ビデオライブラリー',
    },

    adminNavigationBar: {
      dashboard: 'ダッシュボード',
      backToMainMenu: 'メインメニューに戻る',
      noTutorial: 'This page does not have a tutorial yet',
    },

    actionLog: {
      noAction: '未対応',
      show: '表示する',
      hide: '隠す',
      action: {
        comment: 'コメントあり',
        invite: '面接案内済',
        reInvite: '面接案内再送済',
        smsInvite: 'SMSで面接に招待しました',
        smsReInvite: 'SMSで候補者に招待を再送信する',
        videoResponse: 'ビデオ面接回答済',
        message: 'Eメール送付済',
        personalInterviewMessage: '予定済の面接の招待を送信しました',
        smsMessage: 'added SMS message to message queue',
        PersonalInterviewInvitationRemoved: 'deleted previous invitation to scheduled meeting',
        videoMessage: 'ビデオメッセージ送付済',
        applicationCreatedByAdmin: '追加された応募者',
        stageChanged: placeholderKeys => `右記ステップに移動しました： ${placeholderKeys.stage}`,
        answeredToInterview: placeholder => `面接回答済応募者 ${placeholder.opening}`,
        applicationCreated: '新規応募がありました。',
        applicationUpdated: '応募内容が更新されました。',
        candidateUpdated: '候補者が更新されました',
        introductionToOne: placeholders => `候補者を${placeholders.introducee}に紹介しました。`,
        introductionToMany: placeholders => `候補者を${placeholders.introduceeCount} 受信者に紹介しました。`,
        calendarEventCreated: placeholders => `候補者は面接を確認しました。: ${placeholders.eventStartTime}`,
        addRating: '評価を追加しました',
        deleteRating: '評価を消去しました',
        withdrew: '候補者はプロセスへの参加をやめます。',
        resetQuestionResponse: 'さんは候補者の回答を削除した',
      },
      videoLink: {
        linkText: '表示する',
      },
    },

    additionalFormFields: {
      title: '追加設問項目',
      description: context => (context === '面接'
        ? '面接案内を送付後は、追加設問項目を削除することができません。'
        : '募集ポジションに応募があった後は、追加設問項目を削除することができません。'),
      add: '新しい項目を追加',
      delete: '削除',
      done: '完了',
      cancel: '取消',
      edit: '修正',
      required: '必須',
      optional: '非必須',
      notAsked: '表示しない',
      shortText: '短文テキスト',
      longText: '長文テキスト',
      addOption: '追加する',
      singleSelect: '単一選択',
      multiSelect: '複数選択',
      fieldLabelPlaceholder: '応募者向けラベル項目',
      fieldNamePlaceholder: '採用担当者のフィールド名',
      addLabel: 'ラベルを追加する',
      addName: '名前を追加する',
      nameLabel: 'フィールドラベル',
      typeLabel: '項目分類',
      optionLabel: '項目オプション',
      settingsLabel: 'フォームの設定',
      reorder: '順番変更',
      stopReordering: '順番変更の中止',
      optionPlaceholder: 'オプションの追加',
      optionError: 'オプションはすでに存在します',
    },

    addPublicQuestions: {
      title: '動画設問',
      description: '応募者へのメッセージと共に、動画設問を登録してください。',
    },

    addQuestions: {
      edit: {
        start: '設問の順番を入れ替える',
        stop: '設問の順番入れ替えをやめる',
      },
      placeholder: isMobile => (isMobile ? '設問動画をアップロードもしくは録画してください。' : '新規録画する'),
      textQuestionPlaceholder: 'クリックして質問を書く',
      videoPlaceholder: isMobile => (isMobile ? '設問動画をアップロードもしくは録画してください。' : '新規録画する'),
      library: 'ライブラリから選択する',
      text: 'テキスト設問',
      record: '録画',
      upload: 'アップロード',
      answerable: '回答可能な設問',
      takeLimitLabel: '撮影回数',
      answerTimeLabel: '回答時間',
      preparationTimeLabel: '準備時間',
      questionPlaceholder: '設問内容を入力',
      cancel: 'キャンセル',
      add: '追加',
      unlimitedLabel: '「指定なし」',
    },

    addVideo: {
      title: 'イントロ動画',
      description: 'イントロ動画を公開することで、貴社の採用ブランディングを強化しましょう。',
    },

    adminCoverPhoto: {
      welcome: name => `ようこそ, ${name}さん!`,
      photo: '背景ビジュアルを追加する',
      removePhoto: '背景のイメージを削除する',
    },

    adminFooter: {
      licenseLink:
        'https://www.recright.com/en/user-agreement/RecRight-license_agreement.pdf',
      privacyPolicyLink: 'https://new.recright.com/privacy-policy',
      termsLink:
        'https://new.recright.com/recright-terms-and-conditions-recruiter',
      accessibilityReportLink: 'https://new.recright.com/hubfs/RecRight_Accessibility_report.pdf',
    },

    applicationFormSetup: {
      title: '応募フォームの設定',
      notAsked: '表示しない',
      optional: '非必須',
      required: '必須',
      name: 'お名前',
      coverLetter: 'PRメッセージ・カバーレター',
      email: 'Eメール',
      phoneNumber: '電話番号',
      city: '居住都市',
      attachments: '添付ファイル',
      links: '参照リンク',
      questions: '動画設問',
      attachmentsDescription: '添付ファイルの説明',
    },

    billingPlanSelector: {
      select: '選択',
      removeSelection: 'Remove selection',
      month: '/月',
      'recright-ats': 'Recright ATS',
      'recright-video-interview': 'Recright Video Interview',
      'single-recruitment': 'Recright Single',
      'recright-essential': 'Recright Essential',
      'recright-pro': 'Recright Pro',
      'recright-premium': 'Recright Premium',
      'recright-easy': 'Easy',
      'recright-pro2': 'Pro',
      customPlan: 'Recright Custom',
      plans: {
        'recright-easy': {
          info: '毎年10〜20のポジションをご用意して、中小企業様の採用にかかる時間を節約いたします。',
          info2: '',
          features: [
            '50を超えるポジション/年',
            '制限を取り払ったユーザーシート数',
            'ユーザー管理',
            '無料の録画ビデオトレーニング',
            'ブランド化',
            '顧客サポート',
          ],
          unitType: '/月',
        },
        'recright-pro2': {
          info: 'さらにブランド化と管理が必要な大企業様には、年に30〜50のポジションをご用意しております。',
          info2: '',
          features: [
            'Easyに入っているものは何もかも、それに加えて:',
            'レポート',
            'ベストプラクティスのトレーニング',
            'カスタマーサクセス',
          ],
          unitType: '/月',
        },
        'recright-ats': {
          features: [
            '採用管理ツール',
            '応募ランディングページ（無制限）',
            '採用ブランディングムービー掲載',
            '動画設問付き応募フォーム',
            '選考管理',
            '応募者コミュニケーション',
            '採用担当者・評価者エンゲージメント',
            '応募者データベース',
          ],
          unitType: '/月',
        },
        'recright-video-interview': {
          features: [
            'Recright ATSに含まれる全ての機能',
            '録画型ビデオ面接機能',
            '複数の録画設問設定',
            'レポーティングツールReporting tool',
            'オンライントレーニング',
            '最大15募集職種のビデオ面接（1年間あたり）',
          ],
          unitType: '/月',
        },
        'recright-custom': {
          features: [
            '貴社個別の従量価格設定',
            '専任のサポート担当者',
            '貴社採用管理システムとのインテグレーション',
            'ライブ型ビデオ面接',
          ],
          unitType: '/月',
        },
        'recright-essential': {
          features: [
            '15 positions/year',
            'Max 50 candidates/position',
            'Unlimited users',
            'Complimentary recorded video training',
          ],
          unitType: '/月',
        },
        'recright-pro': {
          features: [
            '30 positions/year',
            'Max 50 candidates/position',
            'Unlimited users',
            'Complimentary recorded video training',
            'Best practices training',
            'Enhanced branding: logo, banner, fonts, colors',
            'Candidate Feedback Pulse',
            'Reporting',
            'Dedicated Account Manager',
            'User administration',
          ],
          unitType: '/月',
        },
        'recright-premium': {
          features: [
            'Over 50 positions/year',
            'Unlimited users',
            'Best practices training',
            'Enhanced branding: logo, banner, fonts, colors',
            'Candidate Feedback Pulse',
            'Reporting',
            'Dedicated Account Manager',
            'User administration',
            'ATS integration',
            'Live interview',
            'Active Directory integration',
          ],
          unitType: '/月',
        },
        'single-recruitment': {
          info: '録画されたインタビューの最大出力を試すのに最適です。',
          features: [
            '全機能のご利用',
            '1職種のみの応募ランディングページ・ビデオ面接',
            '60日間の期間限定ご利用 \n\n （応募ランディングページ・ビデオ面接の初期設定完了から起算）',
          ],
          unitType: '/recruitment',
        },
      },
    },

    branding: {
      headerFont: '見出しの書体',
      bodyFont: '本文の書体',
      backgroundColor: '背景の色',
      textColor: '文字の色',
      brandColor: 'ブランドの色',
      buttonTextColor: 'ボタンに表示された文字の色',
      headerTextColor: '見出し文の色',
    },

    cancelSubscription: {
      cancelSubscription: 'ご利用の取消',
      confirmMessage: 'ご利用を取り消しいたします。',
      confirmContent: 'ご利用を取り消してよろしいですか？ 取り消し後に募集職種・ビデオ面接の新規設定はできません。既存の応募者データとビデオ面接履歴は最大90日間まで閲覧いただけます。',
    },

    candidateCard: {
      noStatus: 'ステータス無し',
      lastSeen: time => `最終閲覧 ${time}.`,
      notVisited: '面接未参加',
    },

    chooseLicenseLink: {
      title: 'ライセンスご選択',
    },

    comments: {
      placeholder: 'コメントの追加',
      submit: '追加',
      delete: '削除',
      showComments: '他のコメントを表示する',
      hideComments: '他のコメントを非表示にする',
    },

    competencyList: {
      duplicateError: 'この名前に関する適格性はすでに存在します。',
      defaultText: '使用する適格性が不明な場合は、こちらで設定したデフォルトをご利用いただけます。',
      defaultLinkText: 'デフォルトを取り込む。',
      addCompetency: '新しい能力を追加する',
    },

    competencies: {
      addCompetency: '新規評価項目の追加',
      edit: '評価項目の修正',
      done: '完了',
    },

    competency: {
      warning: '評価項目と評価済み履歴を全て削除しますか？',
    },

    confirmDelete: {
      delete: '削除',
      cancel: 'キャンセル',
      confirm: '了承',
    },

    creditCardFields: {
      cardholderName: 'カード名義人氏名',
      creditCard: 'クレジットカード番号',
      cvv: 'CVV',
      cvvHelp: 'CVVとはクレジットカード背面に記載されている3桁の数字です。',
      expirationDate: '有効期限',
      invalidValue: '設定内容が有効ではありません。',
    },

    currentFilters: {
      currentFilters: '現状のフィルター:',
    },

    discountAmount: {
      neverExpiresDiscount: amount => `無期限ご利用クーポン: ${amount} EUR （クーポンをお持ちの場合）`,
      fixedPeriodDiscount: (amount, cycles) => `期間限定ご利用クーポン: ${amount} EUR （最初の ${cycles} ヶ月間）`,
    },

    discountField: {
      link: 'クーポンを持っています。',
      label: 'クーポンコード',
      invalidValue: 'クーポンコードは無効です。',
    },

    emailForm: {
      emailLabel: 'Eメール',
      defaultButtonText: '送信',
    },

    filterToggler: {
      hideFilters: 'フィルターの非表示',
      showFilters: 'フィルターの表示',
    },

    hashtags: {
      placeholder: 'タグの追加',
      delete: '削除',
    },

    imageInput: {
      errors: {
        format: 'このファイルは画像ではありません。',
        size: '画像ファイルが容量を超えています。4MB以内に設定してください。',
      },
    },

    emailTemplateForm: {
      subjectPlaceholder: '件名',
      messagePlaceholder: 'メッセージ本文',
      namePlaceholder: 'お名前',
      namePlaceholder2:
        'If left blank, uses current user signature or name when sending invites.',
      templateNameLabel: 'テンプレート名',
      titleDisclaimer:
        '[INTERVIEW TITLE]は、招待状を送信する際、インタビューのタイトルに置き換えられる。',
      titleDisclaimerJob:
        '[JOB TITLE] はメッセージ送信時に役職に置き換えられます。',
      confirmLanguageChange:
        '言語を変更してもよろしいですか？保存していない変更はすべて失われます。',
      formatInfo:
        '太字のテキスト、筆記体のテキスト、特殊な書式のリンクを追加できます：',
      cursive: '_筆記体_',
      bolded: '*太字*',
      link: '[http://example.com|リンクテキスト]',
    },

    interviewFormSetup: {
      title: '面接フォーム設定',
      notAsked: '表示しない',
      optional: '非必須',
      required: '必須',
      name: 'お名前',
      email: 'Eメール',
      phoneNumber: '電話番号',
      city: '所在都市',
      attachments: '添付ファイル',
      links: '参照リンク',
      attachmentsDescription: '添付ファイルの説明',
    },

    interviewRow: {
      invites: '招待',
      responses: '回答',
      endTime: '終了日',
      createdAt: '作成日',
      timedTitle: '時間制限付きビデオインタビュー',
      newVideos: '新しい応答',
    },

    introduction: {
      batchIntroduction: count => `${count}受信者に紹介済み`,
    },

    jobAdRow: {
      newApplications: '未確認の応募者',
      applications: '応募',
      publishTime: '公開期日',
      endTime: '公開期限',
    },

    positionStatus: {
      open: date => (date ? `${date} 迄` : ''),
      hidden: date => (date ? `${date} 迄` : ''),
      filled: () => 'ステータス: 締切',
      cancelled: () => 'ステータス: キャンセル済',
      closed: () => 'ステータス: クローズ',
      draft: () => 'ステータス: クローズ (草稿)',
      unpublished: () => 'ステータス: 公開前',
      publishTime: '公開期日',
    },

    jobAdTeaser: {
      add: '新規応募者の追加',
      noApplications: '応募はまだありません。',
      preview: 'ここから求人広告をプレビュー',
      placeholder: {
        first: 'ダイレクトリンクを採用広報にフル活用しましょう。',
        second: '各職種ごとのダイレクトリンクもご利用可能です。',
        third: '上記タイトルバーからたった1クリックで生成されます！',
      },
    },

    list: {
      total: count => `合計: ${count}`,
      selectAll: '全てを選択',
      resetSelection: count => (count > 0 ? `選択を解除 (${count})` : '選択を解除'),
    },

    liveRow: {
      finished: '終了',
      coming: '実施予定',
      active: '実施中',
      titleFallback: 'ライブ面接',
      startTime: '開始時間',
      interviewers: '面接官',
      candidates: '応募者',
      status: 'ステータス',
    },

    loginForm: {
      email: 'Eメール',
      password: 'パスワード',
      submit: 'ログイン',
      changePasswordInfo:
        'Password changed successfully! Please Log in with your new password.',
      error: {
        email: {
          isRequired: 'Eメールアドレスを入力してください。',
          isEmail: value => (value ? `${value} は有効なEメールアドレスではありません。` : ''),
        },
        password: {
          isRequired: 'パスワードを設定してください。',
        },
        login: {
          incorrect: 'ログインできませんでした。',
          deactivated:
            'ユーザーアカウントが無効になっています。貴社のRecright管理者までお問い合わせください。',
          tries: 'セキュリティ担保のため、リトライ回数を制限しています。暫くたってからご利用いただくか、パスワードをリセットしてください。',
        },
      },
    },

    logoUpload: {
      logoTitle: '企業ロゴを表示する',
      removeLogo: 'ロゴを削除する',
      addLogo: 'ロゴを選択してください',
    },

    modalAccountType: {
      title: 'アカウント種別を変更しますか？',
      confirm: '変更',
      cancel: '取消',
    },

    modalApplicationAllInvited: {
      title: '応募者を招待する',
      description: '選択された全応募者は、既に面接へ招待されています。',
    },

    modalApplicationIntroduce: {
      title: '応募者を紹介する',
      description: '応募者の紹介先Eメールアドレスを設定してください。',
      titlePlaceholder: '件名',
      contentPlaceholder: 'メッセージ本文',
      emailsPlaceholder: 'Eメールアドレス',
      namePlaceholder: 'お名前',
      cancel: 'キャンセル',
      sendIntroductions: '紹介メール送信',
    },

    modalApplicationInvite: {
      title: 'ビデオ面接の選択',
      description: '新規ビデオ面接を作成しますか？既存のビデオ面接を使用しますか？',
      createNew: '新規ビデオ面接を作成',
      videoInterviewDescription: '候補者にビデオ面接の招待をし、履歴書の人物と実際に面接する。',
      error: {
        selectInterview: 'ビデオ面接を選択',
      },
      cancel: 'キャンセル',
      close: '閉じる',
      continue: '続ける',
    },

    modalApplicationReInvite: {
      title: '応募者案内の再送信',
      description: '再度応募者に案内するビデオ面接を選択してください。',
      info: '既に閉じられた面接への案内を送ることはできません。',
      cancel: 'キャンセル',
      submit: '案内の再送',
    },

    modalApplicationMessage: {
      title: '選択した応募者へメッセージを送る',
      description: 'どんなメッセージを送信されますか？',
      email: 'Eメールを送る',
      videoMessage: 'ビデオメッセージを送る',
      close: '閉じる',
      cancel: 'キャンセル',
      continue: '続ける',
      sendEmail: 'メッセージを送る',
      emailTitle: '応募者へEメールを送る',
      emailDescription: '選択した応募者へのEメールを記入する',
      videoTitle: '新規ビデオの追加',
      titlePlaceholder: '件名',
      contentPlaceholder: 'こちらにメッセージ本文を入力してください。',
      candidates: '応募者',
      selectedCandidates: '配信対象',
      emailSent: 'Eメールを配信しました!',
      answerable: 'ビデオへの回答可',
      signature: 'よろしくお願い致します。',
    },

    modalAskEmail: {
      title: '見積もりを依頼する',
      description: '是非お気軽にお問い合わせください！ \n\nEメールアドレスをご記入いただけたら、早々に私たちのチームメンバーがご連絡いたします。',
      email: 'あなたのEメールアドレス',
      submit: '問い合わせを送る',
      cancel: 'キャンセル',
      invalidValue: '有効なEメールアドレスではありません。',
    },

    modalAtsTeaser: {
      title: '募集情報を公開し、採用プロセスをスタートする',
      content: '応募者から受け取りたい情報を設定し、募集を開始してください。応募者向けの募集職種ページ（ランディングページ）を使用し、すぐ・簡単にそのリンク情報を各種採用広報にご活用いただけます。また、応募者とのコミュニケーションを適切にとっていただくことで、貴社の企業イメージは効果的に向上します。',
      cancel: 'キャンセル',
      confirm: 'はい。連絡をください。',
      greetings: 'メッセージが送信されました。',
    },

    modalFeedbackPulseTeaser: {
      title: '仕事の応募プロセスに対して、応募者が出した評価について興味がありますか？。',
      content: 'すべての募集の過程について、応募者たちは評価をする機会があります。すべてのフィードバックから出た平均を元に、あなたの総合評価が出されます。',
      cancel: '取り消す',
      confirm: 'はい、連絡してください',
      greetings: 'メッセージの送信が完了しました。',
    },

    modalCandidateMessage: {
      title: count => (count > 1 ? '選択した応募者へメッセージを送る' : '選択した応募者へメッセージを送る'),
      description: 'どんなメッセージを送信されますか？',
      recipients: count => `メッセージは ${count} 名へ送信されます`,
      email: 'Eメールを送る',
      videoMessage: 'ビデオメッセージを送る',
      library: 'ライブラリから選択する',
      close: '閉じる',
      cancel: 'キャンセル',
      continue: '続ける',
      sendEmail: 'メッセージを送る',
      resendInvitation: '案内を再送する',
      resendInvitationSms: 'SMSで招待を再送信する。',
      sms: 'SMSメッセージを送信する。',
      emailTitle: count => (count > 1 ? '応募者へEメールを送る' : '応募者へEメールを送る'),
      emailDescription: '選択した応募者へ送るEメールを記入する',
      libraryTitle: count => (count > 1 ? 'ビデオを応募者へ送る' : 'ビデオを応募者へ送る'),
      videoTitle: '新規動画を追加する',
      titlePlaceholder: '件名',
      contentPlaceholder: 'メッセージ本文をこちらへ記入してください。',
      candidates: '応募者',
      selectedCandidates: '配信対象',
      emailSent: candidates => `${candidates} 件が送信されました!`,
      answerable: 'ビデオへの回答可',
      successMessage: candidates => `${candidates} 件のビデオメッセージが送信されました！`,
      scheduledInterview: '予定済の面接の招待を送る。',
      scheduledInterviewDescription: 'あなたの都合のいい日時を元に、候補者に面接の日程を決めてもらう。',
      reScheduledInterview: '面談のスケジュールを再設定する',
      reScheduledInterviewDescription: '候補者との面接の日を再設定する。以前送った面接の招待はキャンセルされますのでご注意ください。',
      record: '録画',
      upload: 'アップロード',
      required: '*マークが付いた項目は必須入力です。',
      tooManyRecipients: count => `選択された受信数が多すぎます。${count}以内にしてください。`,
      tooLongMessage:
        'メッセージが長すぎます。文字カウンターを確認してください。注意：特殊文字があると、最大のメッセージ長が短くなることもあります。',
    },

    modalEditIntroduceBatches: {
      title: '紹介候補者',
      description: 'ここで募集職種の紹介状況を管理できます。紹介リンクの有効期限を延長したり、受信者を削除したり、募集職種から紹介グループ全体を削除したりできます。',
      noBatches: '紹介はされていません。',
      descriptionWithCount: (candidatesCount, candidateNames) => `${candidateNames}およびその他${candidatesCount}名を次の受信者に紹介しました。`,
      descriptionWithoutCount: candidateNames => `${candidateNames}を次の受信者に紹介しました。`,
      email: 'Eメール',
      expires: '期限切れになります',
      actions: 'アクション',
      visited: '閲覧有',
      extendLinkText: '延長する',
      extendTo: date => `${date}まで延長する`,
      close: '閉じる',
      deleteBatch: 'バッチを削除する',
      deleteBatchWarning: '紹介バッチを削除してもよろしいですか?',
      maxExpirationDate: '有効期限は、本日より起算して10日間以内にしてください。',
      extendedMessage: newExpirationDate => `受信者の紹介リンクの有効期限を${newExpirationDate}まで延期しました!`,
      url: 'URL',
      introductionLink: 'Link',
    },

    modalEditEmailSettings: {
      customReplyToTitle: '招待状メッセージの送信者情報',
      customReplyToSubtitle:
        'この欄には送信者名とインタビュー招待状の返信アドレスの編集が可能です。空欄にした場合、招待状を送信したユーザーの名前とメールアドレスが使用されます。',
      customReplyToEmail: 'インタビュー招待状の返信メール',
      customReplyToName: 'インタビュー招待状の送信者名',
      saveSuccess: '設定が保存されました。',
    },

    modalEditInvitationMessage: {
      title: 'インタビューの招待メッセージを編集',
      info: '修正する面接を選択してください。',
      close: '閉じる',
      saveTemplate: 'このインタビューの招待メッセージとして保存',
      templateSaved: '面接用テンプレートとして保存が完了しました。',
      templateOptionsLabel: 'Select template',
    },

    modalEditStages: {
      title: '採用ステップを修正する',
      info: '貴社ステップに合わせてカスタムステップを追加・修正・削除いただけます。既に応募者が当該ステップに存在する場合には同ステップを削除することができません。',
      addNewStage: '新規ステップを追加する',
      removeDisabled: 'このステップには応募者が存在するため削除できません。',
      error: 'このステップは既に存在しています。',
      done: '完了',
      save: '保存',
      close: '閉じる',
      delete: '削除',
      cancel: 'キャンセル',
      confirm: '了承',
    },

    modalHidePositionsFromUser: {
      modalHeader: '非表示の募集職種',
      modalDescription: name => `ユーザー ${name}に表示する募集職を管理する。`,
      hiddenFrom: name => `ユーザー ${name}に表示しない募集職`,
      noResults: '結果ゼロ',
      noPositions: '募集職なし',
      jobAdLabel: '求人広告',
      interviewLabel: 'ビデオ面接',
      total: total => `${total} 募集職合計`,
      close: '閉じる',
      hide: '非表示にする',
      remove: '削除する',
      searchInfo: '非表示の募集職を閲覧する',
      searchPlaceholder: '職種名か勤務地で検索する',
      labels: {
        title: '職種名',
        location: '勤務地',
        time: '作成日',
        actions: 'アクション',
      },
    },

    modalRemoveUserFromOrganisation: {
      modalHeader: 'この組織からユーザーを削除しています',
      modalDescription: name =>
        `ユーザー${name}は外部ユーザーであり、この組織からのみ削除されます。削除しても、Recright内の他の組織へのアクセスは維持されます。`,
      modalExplanation: name =>
        `その結果、ユーザーはこの組織内のポジションにアクセスできなくなります。${name}が唯一のリクルーターであったポジションへのアクセス権が継承されます。`,
      adminInRecruitmentTeam: name =>
        `ユーザー${name}が採用チームの一員であったポジション：`,
      noResults: '結果ゼロ',
      noPositions: '募集職なし',
      jobAdLabel: '求人広告',
      interviewLabel: 'ビデオ面接',
      total: total => `${total} 募集職合計`,
      close: '閉じる',
      remove: '組織から削除する',
      removeUserConfirmMessage: 'ユーザーを削除する',
      removeUserConfirmContent:
        'この組織からユーザーを削除してもよろしいですか？',
      labels: {
        title: '職種名',
        time: '作成日',
        creator: '新しいポジションのオーナー',
      },
      otherAdmin: '採用チーム内のその他の管理者',
    },

    modalPersonStage: {
      new: '新規',
      hired: '内定',
      proceed: '進行中',
      personalinterview: '対面型面接',
      withdrawn: '辞退',
      scheduledinterview: '予定済の面接',
      rejected: '不合格',
      videointerviewed: 'ビデオ面接済',
      change: '応募者のステップを移動する',
      info: '選択した応募者のステップを別のステップへ移動します。この情報は応募者には公開されません。',
      done: '完了',
      cancel: 'キャンセル',
      changed: '素晴らしい!',
      changedInfo: stage => ` "${stage}" ステップへの移動が完了いたしました。是非応募者にその旨をお知らせ下さい！ \n\n Eメールかビデオメッセージを送付しましょう。`,
      close: '閉じる',
      reopenProcessConfirmPlural: 'こちらの候補者を「辞退者」リストから外し、採用プロセスに戻しますか？ この操作の承認後、候補者は完了していない面接の質問に答えることができるようになります。',
      withdrawConfirmPlural: 'この候補者を採用プロセスから除外しますか？ 除外した場合、その候補者は招待した一切の面接の質問に回答できなくなります。',
      changeSingle: 'この応募者のステップを移動する',
      infoSingle: 'この応募者のステップを別のステップへ移動します。この情報は応募者には公開されません。',
      changedInfoSingle: stage => `${stage}" ステップへの移動が完了いたしました。是非応募者にその旨をお知らせ下さい！ \n\n Eメールかビデオメッセージを送付しましょう。`,
    },

    modalInterviewAdd: {
      timedTitle: '時間制限付きビデオインタビュー',
      timedDescription: '候補者は、設定時間内で質問に回答し録音します。採用担当者は、それぞれの質問で与えられる回答時間と回答を準備する時間を設定できます。',
      title: '新しい面接の作成',
      description: '作成したい面接動画の種類を選びます。',
      friendlyTitle: '標準的な動画面接',
      friendlyDescription: '応募者は動画を何度でも撮り直せます。また、1回の撮影時間に制限はありません。',
      cancel: 'キャンセル',
      continue: '続ける',
    },

    modalLiveInterviewAdd: {
      title: 'Create new live interview',
      description: 'Choose the type of live interview you want to create.',
      basicTitle: 'Normal live interview',
      basicDescription: 'The time of the live interview is chosen by you.',
      scheduledTitle: 'Scheduled live interview',
      scheduledDescription:
        'The time of the live interview is chosen by the candidate based on your availability.',
      cancel: 'キャンセル',
      continue: '続ける',
    },

    modalInterviewPublish: {
      modalTitle: '公開設定',
      publicTitle: '公開型面接',
      publicDescription: 'この面接は貴社の採用広報や企業ウェブサイトに活用いただける公開型ページです。貴社に興味を持ったどなたでも設問を閲覧し、その上で応募を判断することが可能となります。設問への回答が開始された時点で貴社にリマインダーが送信されます。',
      publishButton: '公開リンクを生成する',
      unPublishButton: '公開リンクを削除する',
      title: '埋め込み型面接',
      description: '単一設問のみのビデオ面接の場合、貴社の企業ウェブサイトにシームレスに埋め込みが可能です。応募者はEメール・リンク（LinkedIn等）と共に１つのビデオ設問に回答することで応募します。',
      descriptionMultiple:
        'ビデオ面接を求人情報や企業のホームページにシームレスに統合します。志望者のメールアドレスの入力やビデオ応答の記録が容易になるだけでなく、追加情報をLinkedInプロフィールへのリンクに含めることも可能です。',
      embedNotification: '埋め込み型型面接の場合、その他の属性情報入力・設問を設定することはできません。',
      embedButton: '埋め込みコードを生成する',
      unEmbedButton: '埋め込みを削除する',
      close: '閉じる',
      oneError: '埋め込み型面接は単一設問しか設定できません。複数設定されている設問を削除し単一設問へ変更してください。',
      subscriptionNeeded: 'この面接を公開するには有効化するためのお申し込みが必要です。',
    },

    modalInterviewIntroduce: {
      title: count => (count > 1 ? '応募者を紹介する' : '応募者を紹介する'),
      description: '応募者の紹介先Eメールアドレスを設定してください。',
      titlePlaceholder: '件名',
      contentPlaceholder: 'メッセージ本文',
      emailsPlaceholder: 'Eメールアドレス',
      namePlaceholder: 'お名前',
      cancel: 'キャンセル',
      sendIntroductions: '紹介メール送信',
      selectedCandidates: count => `${count} 名の応募者が選択されました。`,
      successMessage: (candidates, introducees) => `${candidates} 名の応募者が ${introducees} 名に紹介されました。`,
      infoMessage: (candidates, introducees, isInTeam) => `${candidates} 名の応募者が ${introducees} 名に紹介されました。 ${isInTeam} 名は既に採用活動に参加しています。`,
      alreadyInTeam: inTeam => (inTeam > 1 ? '名が既に採用活動に参加しています。' : '名が既に採用活動に参加しています。'),
    },

    modalIntroduce: {
      title: count => (count > 1 ? '候補者を紹介する' : 'この候補者を紹介する'),
      descriptionFirst: '紹介機能を使用して、選択した候補者を同僚や顧客に紹介できます。',
      descriptionSecond: ' 紹介する受信者のメールアドレスを以下に入力してください。受信者に表示したい候補者の情報を選んでください。受信者には選択した情報のみが表示されます。「評価」や「能力と適合性」を選択した場合、受信者は自分の評価を入力したり平均評価を確認したりできます。',
      descriptionThird: 'オプションとして、パスコードを設定して紹介情報を保護することもできます。この場合、受信者はパスコードを入力しない限り、紹介されている候補者を確認できません。',
      descriptionFourth: days =>
        `本紹介情報の有効期間は${days}日間です。紹介情報の設定から、期限を延長することができます。紹介情報の設定は「編集」メニューの下から見つけることができます。`,
      titlePlaceholder: '動画ライブラリ',
      contentPlaceholder: 'メッセージ本文',
      emailsPlaceholder: 'Eメールアドレス',
      namePlaceholder: 'お名前',
      cancel: 'キャンセル',
      sendIntroductions: '紹介情報を送信する',
      selectedCandidates: count => `紹介する候補者として${count} 名を選定`,
      successMessage: (candidates, introducees) => `候補者の${candidates}を紹介先の ${introducees}に紹介`,
      infoMessage: (candidates, introducees, isInTeam) => `候補者の${candidates} を紹介先の ${introducees} に紹介しました。${isInTeam} はすでに採用チームに所属していました`,
      alreadyInTeam: inTeam => (inTeam > 1 ? 'はすでに採用チームに所属しています。' : 'はすでに採用チームに所属しています。'),
      name: 'お名前',
      email: 'Eメール',
      phone: '電話番号',
      city: '居住都市',
      coverLetter: 'PRメッセージ・カバーレター',
      attachments: '添付ファイル',
      links: '参照リンク',
      competencies: 'コンピテンシー・適合度',
      videoResponses: 'ビデオでの回答',
      comments: 'コメント',
      rating: '評価',
      informationsHeader: '紹介する情報を選択する',
      messageHeader: '紹介メッセージ',
      selectAll: '全てを選択',
      resetSelection: '選択をリセットする',
      usePasscodeText: '紹介グループをパスコードで保護する',
      passcode: 'パスコード',
      generatePasscode: '新しいパスコードを生成する',
      copyToClipboard: 'クリップボードにコピー',
      copySuccess: 'パスコードをコピーしました！',
      close: 'Close',
      introduceLinkButton: 'Create link',
      introduceLink: 'Introduce link',
      introduce: 'Introduce',
      formError: 'Error',
      linkCreationError: 'Error creating introduction link',
      link: 'Link',
      continue: '続ける',
    },

    modalInterviewInvite: {
      senderInfo: '招待は、invitations@recright.com の電子メール アドレスから送信されます。',
      replyToEmail: 'インタビュー招待状の返信メール',
      replyToName: 'インタビュー招待状の送信者名',
      replyToInfo: 'これらのフィールドはインタビュー編集ページで編集可能です。',
      notAnswerable: '非公開型の面接、もしくは回答可能な設問設定がされていない面接には評価者を招待できません。',
      title: '応募者に案内する',
      description: '案内する応募者のEメールアドレスを全て入力してください。',
      description2: '応募者が返信した場合はEメールで通知が届きます。案内の送信後は設問を追加することはできませんのでご注意ください。',
      smsDescription: 'Eメールで招待を候補者に送信すると、SMSでのメッセージ送信が可能になります',
      addressesPlaceholder: '応募者のEメールアドレス',
      submit: '案内を送る',
      cancel: 'キャンセル',
      close: '閉じる',
      templateChangedInfo: '案内メッセージを修正しました。修正内容は本対象者に送付されますが、面接に紐付けて保存されていません。',
      saveTemplate: 'このインタビューの招待メッセージとして保存',
      templateSaved: 'この面接に紐付けたテンプレートとして保存されました。',
      inviteInfo: (newInvitees, stage) => `案内メッセージは選択した ${newInvitees} 名の応募者に送付されます。全ての選択された対象者が "${stage}”ステップに移動します.`,
      invitesSent: (success, failed) => (failed > 0 ? `${success} 通の案内が送付され、 ${failed} 名の送付に失敗しました.` : `${success} 通の案内が送付されました。`),
      subscriptionNeeded: '候補者を招待するには、有効なサブスクリプションが必要です。',
      templateOptionsLabel: 'テンプレートを選択',
      rrTemplateOptionLabel: 'Recrightのデフォルトテンプレート',
      interviewTemplateOptionLabel:
        'このインタビューに保存された招待メッセージ',
    },

    modalInterviewInviteSms: {
      title: '招待が送信されました',
      description: count => `${count} 招待が送信されました`,
      description2: '候補者にSMSでも招待を送信しますか？',
    },

    modalSmsMessage: {
      description: count => `メッセージは ${count} 名へ送信されます`,
      phonePlaceholder: '電話番号',
      title: 'SMSメッセージを送信する',
      invitationTitle: 'SMSで招待を送信する',
      resendInvitationTitle: 'SMSで招待を再送信する',
      missingInvitationDescription: count => `${count} 受信者は招待されていません。以下に招待メッセージを入力してください。`,
      missingPhone: count => `${count} 受信者の有効な携帯電話番号がありません。`,
      missingPhone2: '以下のフィールドに携帯電話番号を入力してください。',
      successMessage: count => `${count} SMSメッセージを送信しました`,
      partialSuccessMessage: (successCount, failedCount) => `${successCount} SMSメッセージを送信しました。 ${failedCount} 宛のSMSは配達されませんでした。`,
      failedMessage: '受信者へのSMSメッセージはどれも送信できませんでした。',
      recipientsNotFound: '予期せぬエラーが発生しました。後ほど再度お試しいただき、問題が解決されない場合はサポート部門までお問い合わせください。',
    },

    modalInterviewStatus: {
      change: '面接ステータスを変更する',
      changed: '変更された面接ステータス',
      changedInfo: '面接ステータスが変更されました。この決定を応募者に通知することをお忘れなく！',
      info: 'この面接のステータスを選択し変更してください。',
      open: '受付中',
      closed: '終了',
      done: '完了',
      close: '閉じる',
      endTimeInPast: '面接の終了日が過去の日付になっています。面接を開くと終了日が削除されます。次のリンクから新しい終了日を設定できます。',
      endTimeInPastLink: 'ページを編集する。',
      cancel: 'キャンセル',
    },

    modalInterviewSelectForEdit: {
      title: '面接設定の修正',
      info: '修正されたい面接を選択してください。',
      cancel: 'キャンセル',
      done: '完了',
      error: {
        selectInterview: '面接を選択してください。',
      },
    },

    modalInterviewTeaser: {
      title: 'ビデオ面接で正しい選考を実現しよう。Make the right choice with video interviews',
      content1: 'ビデオ面接は、書類応募後の次ステップとして非常に効果的です。',
      upgradeTitle: '月295EURにアップグレード',
      upgradeDescription: 'ご利用プランを、年間15ビデオ面接職種にアップグレートしましょう。これにより現在のご利用プランは更新されます。',
      singleHireTitle: price => `Recright Single: ${price} EUR/面接〜`,
      singleHireDescription: '60日間ご利用いただける1募集職種のみのビデオ面接プランです。',
      tryTitle: '無料トライアル',
      tryDescription: 'ビデオ面接を作成し、動画設問を設定しましょう。実際に応募者に案内するためにはプランのアップグレードもしくはRecright Singleプランの購入が必要となります。',
      contactTitle: 'お問い合わせ',
      contactDescription: 'お気軽にお問い合わせください。翌営業日までにご連絡致します！',
      cancel: 'キャンセル',
      confirm: '続ける',
      greetings: 'メッセージが送信されました。',
      confirmTitle: '購入を決定する',
      confirmDescription: '簡単・効果的なビデオ面接を手にいれるには、もう1クリック。お支払いをご確認いただけましたら、すぐにご利用可能です！',
    },

    modalJobAdPreview: {
      title: '求人広告のプレビュー表示',
      description: 'このプレビュー表示で、応募者が見る求人広告のイメージを確認できます。',
      description2: 'ご注意：プレビュー表示の広告で使われている言語は、実際の求人広告用に設定した言語と異なります。',
      close: '閉じる',
      back: '戻る',
    },

    modalJobAdStatus: {
      change: '募集ステータスの変更',
      changed: '募集ステータスが変更されました。',
      changedInfo: '募集ステータスが変更されました。応募者へのアナウンスをお忘れなく。',
      info: '新たな募集ステータスを選択してください。ステータスを「締切」もしくは「キャンセル」に変更される場合は、採用決定者の選定、あるいはお断り連絡の送付プロセスに進みます。',
      open: '受付中',
      filled: '締切',
      cancelled: 'キャンセル',
      done: '完了',
      close: '閉じる',
      draft: '閉じる (草稿)',
      closed: '終了',
      unpublished: '公開前',
      hidden: '隠し設定',
      openDescription: '募集情報の公開は右記までとなります：',
      filledDescription: '採用が充足したため、募集情報を閉じて締め切ります。',
      cancelledDescription: '採用が中止となったため、募集情報を閉じて終了します。',
      closedDescription: '募集情報を閉じることにより、閲覧もできない設定とします。',
      hiddenDescription: '募集情報を一般公開せず、ダイレクトリンクでのみ閲覧可能とします：',
      unpublishedDescription: '募集情報を非公開とし、閲覧もできない設定とします。',
      cancel: 'キャンセル',
    },

    modalJobPositionTeam: {
      addAnother: 'メールアドレスを登録して、ユーザーを追加する。',
      team: '採用チーム',
      info: '管理者を追加することができます。',
      newMembersMsg: 'Recrightに既存のアカウントを持たない新しいチームメンバーは、所属する組織のポジションに追加されます。ユーザーの電子メールドメインが組織にリンクされているドメインと一致しない場合、ユーザーには最小限のユーザー権限しか与えられません。ユーザー権限は、ユーザー管理にアクセスできる管理者により、後ほど変更されることがあります。',
      asteriskSymbol: '※',
      currentTeam: '現在のチームメンバー',
      done: '完了',
      remove: '削除',
      submit: 'チームメンバーの追加',
      cancel: 'キャンセル',
      selfRemovedMessage: '採用チームから退出しました。',
      successMessage: count => `${count}人のメンバーを採用チームに加えました。`,
      errors: {
        duplicate: 'このEメールは既に登録されています。',
        duplicateMultiple: 'メンバーは、すでに1つ以上のメールで登録されています。',
        isEmail: '無効なメールアドレスです。',
        isEmailMultiple: '無効なメールアドレスが見つかりました。',
        isRequired: '必要事項を記入してください。',
      },
    },

    modalJobPositionCopy: {
      title: (context, position) => `本当に募集職種を複製しますか？ ●複製対象： ${context === 'jobAd' ? 'job' : 'interview'} "${position.title}"?`,
      admins: '採用チームメンバーも含んだ上で複製しますか？',
      done: '完了',
      cancel: 'キャンセル',
    },

    modalVideos: {
      title: '動画ライブラリ',
      yourVideos: 'あなたのビデオ',
      companyVideos: '会社のビデオ',
      sort: {
        createdAt: '作成期日',
        title: '件名',
      },
      add: '追加',
      done: '動画を追加',
      cancel: 'キャンセル',
    },

    modalUsersAdd: {
      title: 'ユーザーを招待する',
      languageDescription: 'こうしたユーザーは次の言語を使えます。',
      permissionsDescription: '各登録済ユーザーの許可された権限一覧:',
      emailsPlaceholder: 'ユーザーのEメールアドレス登録',
      seeAllPositions: '全ての募集職種閲覧',
      createJobPositions: '募集職種の作成',
      createInterviews: '面接の作成',
      account: '企業情報の修正',
      billing: 'ご請求処理',
      reporting: 'レポーティング',
      editUsers: 'ユーザー設定',
      default: '初期化',
      cancel: 'キャンセル',
      submit: 'ユーザーを招待する',
    },

    modalCompanyDefaultPermissionsEdit: {
      title: 'デフォルト許可:',
      description: 'サインアップする全てのユーザーは自動的にデフォルト設定となります。',
      seeAllPositions: '全ての募集職種閲覧',
      createJobPositions: '募集職種の作成',
      createInterviews: '面接の作成',
      account: '企業情報の修正',
      billing: 'ご請求処理',
      reporting: 'レポーティング',
      editUsers: 'ユーザー設定',
      cancel: 'キャンセル',
      submit: '保存',
    },

    modalOtherApplications: {
      title: '他の役職での候補者。',
      header: '他の役職での同じ候補者のリストはこちらです。',
      close: '閉じる',
    },

    getPermissionsLabels: {
      permissions: {
        seeAllPositions: '全ての募集職種閲覧',
        createJobPositions: '募集職種の作成',
        createInterviews: '面接の作成',
        account: '企業情報の修正',
        billing: 'ご請求処理',
        reporting: 'レポーティング',
        editUsers: 'ユーザー設定',
        default: 'デフォルト許可',
      },
    },
    // TODO: Translations missing!
    modalCronofy: {
      linkCalendar: {
        title: 'Link your calendar to Recright',
        description: 'Use our partner Cronofy to link your calendar to Recright',
        authorize: 'Authorize your calendar here',
        authorized: profileName => `You have successfully linked calendar ${profileName} to your Recright account`,
        revokeAuthorization: 'Unlink the calendar from Recright',
      },
      personalInterview: {
        title: 'Create the invitation for scheduled interview',
        description: 'If you’d like to meet the candidate in person, you may invite them to self-schedule a meeting. First, choose the interviewers for the meeting, then set your availability by choosing the dates, times as well as the length of the slots. Add in a message to personalize your invitation. \n\nThe candidate will receive an email to book the meeting. When the candidate chooses a time slot, the interviewers will get an email confirmation with the candidate’s details, and the meeting will appear on the calendar.',
        interviewersHeader: 'Select interviewers',
        noInterviewersSelected: 'Select at least one interviewer with linked calendar to continue',
        otherInterviewersHeader: 'Other interviewers',
        removeOtherInterviewers: 'Remove',
        deselectAll: 'Deselect all',
        selectAll: 'Select all',
        interviewerCalendarNotConnected:
          "The user's calendar is not connected to Recright, and their availability information cannot be accessed.",
        interviewerCalendarNotConnected2:
          "They'll receive an email with scheduling information and instructions on how to connect their calendar to Recright.",        singleInterviewer: 'Interviewer',
        allInterviewersCalendarNotConnected: 'None of the interviewers have their calendar connected to Recright',
        addMoreInterviewersToTeam: 'Click here to add more interviewers to the team',
        userCalendarNotConnected: 'You don\'t have your calendar connected to Recright',
        userConnectCalendar: 'Connect your calendar here',
        addNewInterviewer: 'Add new interviewer\'s email address',
        timeSlot: {
          description: 'Choose the timeframe and interview length for the interview.\nAfter that you see what slots are available for candidate to choose from.',
          startDate: 'Timeframe start date',
          endDate: 'Timeframe end date',
          endDatePlaceholder: 'End date',
          startDatePlaceholder: 'Start date',
          endDateWarning: 'Select the time frame end date for the scheduled meetings',
          startTime: 'Start time for the day',
          endTime: 'End time for the day',
          timezone: 'Time zone',
          timezoneHelp: 'Please note that changing the timezone also adjusts date and time accordingly.',
        },
        useAllTimeSlots: 'Let candidate choose from all available time slots in the chosen timeframe',
        noTimeSlotsSelected: 'Select at least one timeslot from the Availability below\nor let the candidate choose from all available time slots',
        slotPickerDescription: 'See what slots are available for candidate to choose from.',
        showAvailability: 'Show availability',
        refreshAvailability: 'Refresh availability',
        slotLength: 'Slot length',
        availabilityError: 'Unable to show availability. Please try again later and if the problem persists please contact our support.',
        recipients: count => `Message will be sent to ${count} candidates`,
        confirmRescheduleMessage: '面談のスケジュールを再設定する',
        confirmRescheduleContent: 'すでに面接の日程が設定されています。新しい日程を送信しますか？前に設定した面接のスケジュールは上書きされます。',
      },
      personalInterviewMessage: {
        title: 'Create message for calendar invitation',
        successTitle: 'Great',
        successDescription: candidateLength => `You invited ${candidateLength} people to personal interview. They have also been moved to stage 'Personal Interview'`,
        message: {
          emailMessage: 'Email message',
          title: title => `Let’s have a meeting regarding ${title}`,
          content: title => `Hey! We were impressed with your application for ${title} position and would like to invite you for a meeting and tell you a little more about the position and get to know you better.\n\nPlease let me know which of the following times best for you by clicking this scheduling link.\n\nLooking forward to meeting you!`,
          event: {
            header: 'Calendar event information',
            description: 'Insert here information that is included in the calendar event',
            titlePlaceholder: 'Event title',
            locationPlaceholder: 'Event location',
          },
        },
        close: 'Close',
        saveDefaultLocation: 'Save location as default location',
        savedDefaultLocation: 'Saved as default location',
        invitationError: 'We were unable to send calendar invitation. Please try again later and if the problem persists please contact our support.',
      },
    },

    // TODO: Translations missing!
    modalVideoEdit: {
      save: '保存',
      cancel: 'キャンセル',
      addTag: 'タグの追加',
      title: '動画を編集',
      success: '動画の変更を保存しました！',
      error:
        '変更を保存できませんでした。後でもう一度お試しください。それでも問題が解決しない場合は、サポートにご連絡ください。',
    },

    noResults: {
      description: '該当するものがありません。もしフィルタリングしている場合には、条件を緩和して再実行してください。',
    },

    notifications: {
      notifications: '通知',
    },

    notificationsSubscribeButton: {
      subscribe: '加入する',
      subscribed: '加入済み',
      unsubscribe: '加入を取り消す',
    },

    onboardTutorial: {
      ui: {
        back: '戻る',
        close: '閉じる',
        last: '最終項目',
        next: '次へ',
        skip: '止める',
      },
      dashboard: [
        {
          title: 'Welcome to Recright!',
          text: 'First things first — let’s connect your calendar, so you can schedule meetings with your candidates quickly, without sending emails back and forth! <a href="/admin/account">Connect your calendar here!</a>',
          selector: '.joyride--welcome-calendar',
          position: 'top',
          style: {
            beacon: {
              offsetY: -625,
            },
          },
        },
        {
          title: 'ようこそ、Recrightへ!',
          text: 'こちらでは、インタラクティブにご案内いたします。パルスボタンをクリックすることで補足説明の文章をお読みいただけます。この文章は、各ページにおいて「チュートリアルを見る」ボタンをクリックすることにより何度でもご覧いただくことが可能です。',
          selector: '.joyride--welcome',
          position: 'top',
          style: {
            beacon: {
              offsetY: -625,
            },
          },
        },
        {
          title: '募集職種の新規作成',
          text: '新たな募集職種を設定し、応募ランディングページを作成することで、応募受付を開始します。',
          selector: '.joyride--add-job-ad',
          position: 'bottom-left',
        },
        {
          title: 'ビデオ面接の新規作成',
          text: '新たなビデオ面接選考を作成し、応募者に案内を送付します。',
          selector: '.joyride--add-videointerview',
          position: 'bottom-left',
        },
        {
          title: '設定',
          text: 'アカウント設定、応募ランディングページ情報の取得、動画ライブラリの管理や言語設定等をご利用いただけます。また「チュートリアルを見る」をクリックすることでパルスガイドを起動することが可能です。',
          selector: '.joyride--profile-settings',
          position: 'bottom-left',
        },
      ],
      // TODO: Translations missing!
      accountDetails: [
        {
          title: 'Connect your calendar here!',
          text: 'Come on! Do it! Do it now! What are you waiting for?! Do it now!',
          selector: '.joyride--connect-calendar',
          position: 'top',
        },
      ],
      jobAdEdit: [
        {
          title: 'ヘッドバナー・ロゴの追加',
          text: '募集職種にはヘッドバナーを追加することができます。画像の推奨サイズは1440 x 320ピクセルです。ロゴデータを設定するのも忘れないようにしましょう。',
          selector: '.joyride--job-ad-images',
          position: 'top',
        },
        {
          title: 'タイトル, ロケーション, 公開期日',
          text: '募集職種、勤務地、公開期日・締切期日を入力してください。締切期日を空欄のまま設定した場合、無期公開となります。',
          selector: '.joyride--job-ad-title',
          position: 'top',
        },
        {
          title: '募集要項',
          text: 'こちらに募集職種の詳細情報を記載してください。貴社が具体的にどんな方を求めているのか、何が応募条件となるか、そして貴社が何を提供できるのか、という点については最低でも記載されることを強くお勧めいたします。',
          selector: '.joyride--job-ad-description',
          position: 'top',
        },
        {
          title: 'イントロ動画',
          text: 'イントロ動画を応募ランディングページに公開することで、貴社の採用ブランディングを強化しましょう。',
          selector: '.joyride--job-ad-employer-video',
          position: 'top',
        },
        {
          title: '応募フォーム設定',
          text: '応募者から取得されたい項目を選択してください。各項目は、回答非必須/必須の設定が可能です。',
          selector: '.joyride--job-ad-application-setup',
          position: 'top',
        },
        {
          title: '動画設問',
          text: '既に貴社へ応募した方々に対して動画で質問し、生の声で彼らの考えを聞くことができます。貴社にとっても歓迎のメッセージをビジュアルで伝える良い機会となります。',
          selector: '.joyride--job-ad-video-questions',
          position: 'right',
        },
      ],
      interviewEdit: [
        {
          title: 'ヘッドバナー・ロゴの追加',
          text: 'ビデオ面接にはヘッドバナーを追加することができます。画像の推奨サイズは1440 x 320ピクセルです。ロゴデータを設定するのも忘れないようにしましょう。',
          selector: '.joyride--interview-images',
          position: 'top',
        },
        {
          title: 'タイトル, 応募期限：',
          text: 'ビデオ面接のタイトルと応募期限を設定してください。期限を空欄のまま登録されると常時受付となります。',
          selector: '.joyride--interview-title',
          position: 'top',
        },
        {
          title: '面接フォーム設定',
          text: '応募者から取得されたい項目を選択してください。各項目は、回答非必須/必須の設定が可能です。',
          selector: '.joyride--interview-form-setup',
          position: 'top',
        },
        {
          title: '面接設問',
          text: '新たに録画もしくは既存の動画をアップロードし設問として設定してください。設定後にはその動画ファイルをライブラリに保存し、スムーズに再利用いただけます。もし動画でのご用意が難しい場合にはテキスト形式で設問設定をすることも可能です。応募者は常に動画で回答いたします。',
          selector: '.joyride--interview-video-questions',
          position: 'top',
        },
      ],
      createdJobAd: [
        {
          title: '求人広告行動力',
          text: 'ここで 求人広告を編集し、そのステータスを変更して、候補者を評価するためにチームを招待できます。',
          selector: '.joyride--created-actions-left',
          position: 'top',
        },
        {
          title: '職位を奨励する',
          text: '求人広告を出しソーシャルメディアで求人広告を共有すれば、候補者探しも容易になります。',
          selector: '.joyride--created-actions-right',
          position: 'top',
        },
      ],
      createdInterview: [
        {
          title: ' ビデオ面接行動力',
          text: 'ここで ビデオ面接を編集し、そのステータスを変更して、候補者を評価するためにチームを招待できます。',
          selector: '.joyride--created-actions-left',
          position: 'top',
        },
        {
          title: 'ビデオ面接への招待と公開',
          text: '候補者をあなたのビデオ面接に招待するか、あなたのビデオ面接を公開し、ソーシャルメディアとビデオ面接を共有することによって宣伝しましょう。',
          selector: '.joyride--created-actions-right',
          position: 'top',
        },
      ],
      ApplicationView: [
        {
          title: 'コメント・分類',
          text: '応募者に対しコメントを残したり、タグ設定により分類、また５段階の全体評価を保存いただけます。当該応募者に対するステータスを常に最新のものにしておくことで、他の採用チームメンバーが貴方の決定を把握することに役立ちます。応募者は閲覧できませんのでご安心ください。',
          selector: '.joyride--comments',
          position: 'top',
        },
      ],
    },

    organisationSubMenu: {
      index: '組織の特徴',
      branding: 'カスタマイズ設定',
      stages: 'ステップ',
      emailTemplates: 'EEメールテンプレート',
      competencies: 'コンピテンシー',
    },

    passcode: {
      passcode: 'Passcode',
      showPasscode: 'パスコードを表示',
      hidePasscode: 'パスコードを非表示',
    },

    passwordIndicator: {
      errors: [
        '12文字以上のパスワードを設定してください。',
        '128文字未満のパスワードを設定してください。',
        '3文字以上の連続した同じ文字をパスワードに含むことはできません。',
        '最低1文字のアルファベット小文字をパスワードに含む必要があります。',
        '最低1文字のアルファベット大文字をパスワードに含む必要があります。',
        '最低1文字の数字をパスワードに含む必要があります。',
        '最低1文字の記号（例：!, #, &)をパスワードに含む必要があります。',
      ],
      strengthLabel: 'パスワード安全度: ',
      strengthValue: {
        insufficient: '不可',
        weak: '弱',
        medium: '中',
        strong: '強',
      },
      learnMore: 'パスワードをより安全にするためのアドバイス',
    },

    personDetails: {
      namePlaceholder: '候補者',
      links: '参照リンク',
      attachments: '添付ファイル',
      coverLetter: 'PRメッセージ・カバーレター',
      referrer: 'アクセス元',
      referrerInfo: '応募者がアクセスしてきた元のサイト',
      lastSeen: time => `最終閲覧： ${time}.`,
      headerAdditionalInformation: '追加情報',
      state: {
        invited: '案内済',
        visited: '閲覧有',
        incomplete: '未完了',
        completed: '完了',
      },
      notVisited: 'まだ面接画面を訪れていません。',
      otherPersons: count => `他の役職でも ${count} 見つかりました。`,
      name: 'お名前',
      email: 'Eメール',
      phone: '電話番号',
      city: '居住都市',
    },

    personEdit: {
      header: '候補者情報を編集する',
      description: context => `候補者が${context === 'application' ? '応募' : '面接'} フォーム内で閲覧できる基本的な候補者情報はすべて編集できます。`,
      name: ' 名前',
      email: 'Eメール',
      city: '居住都市',
      phone: '電話番号',
      link: 'リンクを追加する（例：LinkedInプロフィールへのリンク）',
      links: 'LinkedInプロフィール等のリンクを追加する',
      coverLetter: 'PRメッセージ・カバーレター',
      attachments: '添付ファイル',
      save: '保存',
      cancel: 'キャンセル',
      editDetails: '情報を編集する',
      editSuccess: '候補者情報を保存しました！',
    },

    personRow: {
      noStage: 'どのステップにも進んでいません。',
      lastSeen: time => `最終閲覧： ${time}.`,
      notVisited: 'まだ面接画面を訪れていません。',
      selectPerson: '選択',
      deselectPerson: '選択を解除',
      openPersonPage: 'オープン',
      icons: {
        messages: messagesSent => `${messagesSent} 通が送信されました。`,
        message: messagesSent => `${messagesSent} 通が送信されました。`,
        noMessages: 'メッセージは送られていません。',
        introduction: introductions => `${introductions} 件が紹介されました。`,
        introductions: introductions => `${introductions} 件が紹介されました。`,
        noIntroductions: '紹介はされていません。',
        comment: comments => `${comments} 件がコメントされました。`,
        comments: comments => `${comments} 件がコメントされました。`,
        noComments: 'コメントはありません。',
        appliedWithLinkedIn: 'LinkedInデータで応募',
      },
      state: {
        invited: '案内済',
        visited: '閲覧有',
        incomplete: '未完了',
        completed: '完了',
      },
    },

    pipeline: {
      editInterview: '面接設定の修正',
      titleLabel: '職種名',
      endTimeLabel: '受付終了予定日：',
      statusLabel: '状態',
      locationLabel: '勤務地',
      editStages: 'ステップの修正',
      interviewSchedulingDescription: 'This stage contains candidates that have peen invited to a personal meeting.',
      pipelineTooltip: '候補者を採用審査の全期間を通じて追跡する。候補者の採用ステージを変更する。候補者を採用ステージあるいは他の基準に基づいてフィルタリングできます。',
    },

    positionListing: {
      type: 'タイプ',
      title: '職種名',
      owner: '所有者',
      created: '作成日 (GMT)',
      start: '公開期日 (GMT)',
      end: '終了日 (GMT)',
      count: '応募者',
      invited: '招待者',
      visited: '訪問者',
      answered: '回答者',
      hired: '採用者',
      leadTime: 'リードタイム',
      leadTimeValue: v => `${v} 日`,
      jobAdLabel: '求人広告',
      interviewLabel: 'ビデオ面接',
      timedLabel: '時間制限付きビデオインタビュー',
      embedLabel: '埋め込み型面接',
      publicLabel: '公開型面接',
      timezone: 'Timezone',
      feedback: 'フィードバック統計',
    },

    qrCodeDownload: {
      download: 'QRコードをダウンロード',
    },

    questionsAndResponses: {
      response: 'レスポンス有',
      noResponse: 'レスポンス無',
      resetQuestionResponse: '志望者の回答を削除',
      resetQuestionResponseConfirm: questionTitle =>
        `志望者への質問"${questionTitle}"をリセットし、その回答を削除してもよろしいですか？`,
      resetQuestionResponseConfirm2:
        'これを実行すれば、志望者が再度この質問に回答することができます。',
    },

    recentPositionsContainer: {
      createNew: '新規作成',
      showAll: 'すべて表示',
    },

    recentJobAds: {
      openJobPositions: '募集職種',
      showAllJobPositions: '全ての募集職種を表示する',
      createNewJobPosition: '募集職種を新規作成する',
      subscriptionNeeded: 'この募集職種を公開するには有効化するためのお申し込みが必要です。',
      confirmSingleHire: 'ご購入いただいているRecright Singleから１点をこの募集職種に利用します。',
      newApplications: '未確認の応募者',
      responses: '応募',
    },

    recentInterviews: {
      openVideoInterviews: 'ビデオ面接',
      showAllVideoInterviews: '全てのビデオ面接を表示する',
      createNewVideoInterview: 'ビデオ面接を新規作成する',
      invites: '招待',
      responses: '回答',
      timedTitle: '時間制限付きビデオインタビュー',
    },

    registrationForm: {
      email: 'Eメール',
      submit: 'サービスにログインするL',
      password: 'パスワード',
      confirmPassword: 'パスワードの確認',
      agreeTos: '私はRecright ユーザー使用条件を読んだ上で、',
      agreeTosLinkText: '承認します。',
      privacyPolicy: '私はプライバシーポリシーを',
      privacyPolicyLinkText: 'よく理解しました。',
      licenseAgreement: '私は代表を務める組織に代わって、',
      licenseAgreementLinkText: 'Recright一般利用規約を受諾します。',
      newsletter: 'マンスリーニュースレターに登録する',
      name: 'お名前',
      namePlaceholder: '名  姓',
      organization: '企業名',
      companyDomain: domain => `この ${domain} ドメインを貴社に紐づけることを許可`,
      error: {
        password: {
          isRequired: 'パスワードが必要です。',
          isValidPassword: 'パスワードには、大文字1文字、小文字1文字、数字1文字を含む最低8文字が必要です。',
          passwordsMatch: 'パスワードがマッチしません。',
        },
      },
    },

    requestCustomPlan: {
      info: 'より多くの応募者に対応されるご意向ですか?',
      cta: 'カスタマイズプランの見積もりを依頼する',
      successMessage: '依頼を完了いたしました。',
    },

    subscriptionNeededAlert: {
      contactPersonWithBillingPermission: '貴社の組織の、請求担当者にご連絡ください',
    },

    search: {
      placeholder: '検索',
    },

    searchFilter: {
      filter: 'フィルター',
      headings: {
        location: '勤務地',
        state: '進行中',
        status: 'ステータス',
        tags: 'タグ',
        rating: '評価',
        stage: 'ステップ',
      },
      state: {
        invited: '案内済',
        visited: '閲覧有',
        incomplete: '未完了',
        completed: '完了',
      },
      status: {
        open: '公開中',
        filled: '締切',
        cancelled: 'キャンセル済',
        closed: '終了',
        draft: '草稿',
        unpublished: '公開前',
        hidden: '非公開',
        hired: '採用',
        new: '新規',
        all: '全て',
        proceed: '進行中',
        videointerviewed: 'ビデオ面接済',
        personalinterview: '対面型面接',
        withdrawn: '辞退',
        scheduledinterview: '予定済の面接',
        rejected: '不合格',
        finished: '終了',
        coming: '予定',
        active: '進行中',
      },
    },

    selectListings: {
      title: 'リスティング',
      description: '公開中募集職種のリスティングを選択する',
    },

    session: {
      account: 'アカウント設定',
      videos: 'ビデオライブラリー',
      language: '言語',
      logout: 'ログアウト',
      whatsNew: 'What\'s New',
      trainingMaterial: 'Recrightトレーニング',
      expired: 'もう１度ログインしてください。',
      showTutorial: 'チュートリアルを見る',
      helpCenter: 'Recright Help Center',
      organization: '企業名',
    },

    showFeedbackPulse: {
      showPulse: 'フィードバックを表示する',
      positive: avg => `${avg}% 好評価`,
      feedbackStatistics: 'フィードバック統計',
      noFeedback: 'まだフィードバックはありません',
      responses: responses => `${responses} 回答数`,
    },

    singleHireUseNotification: {
      notificationHeader: count => `貴社アカウントは ${count} 点のRecright Singleを保有しています。 `,
      notificationBody: '応募者への案内や面接の公開により、1点のRecright Singleを消費します。',
    },

    singleHires: {
      currentCount: count => `${count} 点のRecright Singleをご利用可能です。`,
      purchase: '1点のRecright Singleを購入する',
      label: 'Recright Single',
      confirmMessage: amount => `Recright Single購入を承認してください。 ${amount} ユーロがあなたの登録されたクレジットカードに課金されます。`,
    },

    smartrecruitersPublish: {
      title: 'Smartrecruitersを統合',
      description: 'Smartrecruiters内のビデオ面接リストに、特定の面接を追加・削除できます。',
      notification: '追加した面接がSmartrecruitersに表示されるまでには最長24時間がかかります。',
      addButton: 'Smartrecruitersに追加',
      removeButton: 'Smartrecruitersから削除',
      confirmRemove: '本当にこの面接をSmartrecruitersから削除しますか?',
      addConflict: 'この面接は、すでにビデオ面接リストに追加されています。',
      removeConflict: 'この面接は、すでにビデオ面接リストから削除されています。',
    },

    subscriptionExpired: {
      message: 'ご利用期限が切れています。',
    },

    subscriptionPlan: {
      plan: 'プラン',
      noActivePlan: 'You don\'t have a active plan.',
      changePlan: 'プラン変更',
      createSubscription: '新規申込',
      save: '保存',
      cancel: 'キャンセル',
      errorFromProcessor: error => `支払い処理でエラーが発生しました：${error}`,
    },

    stars: {
      yourRating: rating => `あなたの評価: ${rating}`,
      totalVotes: count => `総合${count}評価`,
      yourRatingReset: 'あなたの評価をリセットする',
    },

    statisticsFilters: {
      timeframe: '時期で検索',
      owner: '所有者 (任意)',
    },

    csStatisticsFilters: {
      timeframe: 'Timeframe',
      autoSuggestCompany: 'Company name',
      companyId: 'Company ID',
      companyDomain: 'Company domain',
      note: 'Note: ',
      noteText:
        'Company name is case sensitive. Company name suggestions are only shown for companies with > 1 jobads or jobopenings.',
    },

    statisticsSummary: {
      jobCountLabel: '募集中の職種数',
      interviewsLabel: 'ビデオ面接',
      applicationsLabel: '応募者',
      answersLabel: '面接での回答',
      activeUsersLabel: 'アクティブユーザー',
      avgLeadTimeLabel: '平均リードタイム',
      avgLeadTimeValue: value => `${value} 日`,
    },

    status: {
      opening: {
        open: '公開中',
        filled: '締切',
        cancelled: 'キャンセル済',
        closed: '終了',
        draft: '草稿',
        unpublished: '公開前',
        hidden: '非公開',
      },
      person: {
        hired: '採用',
        proceed: '進行中',
        new: '新規',
        videointerviewed: 'ビデオ面接済',
        personalinterview: '対面型面接',
        withdrawn: '辞退',
        scheduledinterview: '予定済の面接',
        rejected: '不合格',
      },
    },

    transactionList: {
      noTransactions: '取引履歴はありません。',
      createdAt: '日時',
      type: 'タイプ',
      status: 'ステータス',
      amount: '金額',
      receipt: '領収証',
      statuses: {
        authorization_expired: '期限切れ',
        authorized: '承認済',
        authorizing: '承認中',
        settlement_pending: '決済保留中',
        settlement_confirmed: '決済確認済',
        settlement_declined: '決済却下',
        failed: '失敗',
        gateway_rejected: 'ゲートウェイ不許可',
        processor_declined: 'プロセス停止',
        settled: '決済済',
        settling: '決済中',
        submitted_for_settlement: '決済申込済',
        voided: '無効',
      },
      types: {
        sale: 'Sale',
        credit: 'Credit',
      },
      download: 'ダウンロード',
      downloadReceipt: '領収証ダウンロード',
      notSettled: '決済待',
    },

    trialBanner: {
      notification: days => `貴社のトライアル期間は、あと ${days}  日間です。トライアル期間後のご利用にはお申し込みをお願いいたします。`,
      trialEnded: '貴社のトライアル期間は終了いたしました。ご利用の継続にはお申し込みをお願いいたします。',
      orderHere: 'お申し込みはこちらから',
    },

    updateCreditCard: {
      save: '保存',
      cancel: 'キャンセル',
    },

    favorite: {
      popupHeader: 'ビデオ図書館を選択する。',
      yourVideos: 'あなたのビデオ',
      companyVideos: '会社のビデオ',
    },

    FavoritesInfo: {
      Favorites: videoLibrary => `ハートアイコンをクリックし、お気に入りにビデオを追加してください。 <a href="${videoLibrary}">Video Library</a>からお気に入りを削除することも可能です。`,
    },

    brandingPreview: {
      preview: 'プレビュー',
      header: '見出しサンプル',
      body: lorem => `これは文章書体のサンプルです。 ${lorem}`,
      linkText: 'これはリンクのサンプルです。',
      primaryButtonText: '主要ボタン',
      secondaryButtonText: 'その他ボタン',
      backButtonText: '戻るボタン',
    },

    usersList: {
      generalInformation: '基本情報',
      latestVisit: date => `最新ログイン ${date}`,
      neverLogger: 'ログインしたことがない',
      externalUser: '外部ユーザー',
      inviteExpired: '招待の期限切れ',
      permissions: {
        permissions: '許可権限',
        seeAllPositions: '全ての募集職種閲覧',
        createJobPositions: '募集職種の作成',
        createInterviews: '面接の作成',
        account: '企業情報の修正',
        billing: 'ご請求処理',
        reporting: 'レポーティング',
        editUsers: 'ユーザー設定',
        default: 'デフォルト許可',
      },
      actions: {
        actions: '変更',
        activate: '有効化',
        deactivate: '無効化',
        removeFromOrganisation: '組織から削除する',
        hiddenPositions: '非表示の募集職',
      },
      noUsers: '該当データがありません。入力値を確認し再度トライしてください。',
    },

    usersListFilters: {
      sort: {
        name: '名前',
        email: 'Eメール',
        lastAdminAccess: '最新利用日',
      },
      find: '検索',
      clearSelections: '選択の解除',
      usersCount: count => `合計 ${count} ユーザー`,
    },

    usersListActions: {
      editMultipleUsersPermissions: 'edit multiple users permissions',
      deactivateSelectedUsers: '選択したユーザーの無効化',
      activateSelectedUsers: '選択したユーザーの有効化',
      addNewUsers: 'ユーザーを招待する',
      save: '保存',
      cancel: 'キャンセル',
      editUsersPermissions: '登録済ユーザーの権限設定',
    },

    linkedInInformation: {
      title: 'LinkedIn情報:',
      since: 'Since',
      summary: 'サマリー:',
      fullLinkedInProfile: '全LinkedInプロフィール',
    },

    colorPicker: {
      reset: '初期設定に戻す',
    },

    emailDeliveryStatus: {
      Undetermined: {
        Undetermined: 'アドレスが見つからなかったか、メールを受信できないアドレスであるため、メールは配信されませんでした。',
      },
      Permanent: {
        General: '受信サーバーに受け取りを拒否されたため、Eメールは配信されませんでした。',
        NoEmail: 'Eメールアドレスが存在していません。',
        Suppressed: '以前に送信したEメールが不着のままであるため、Eメールは配信されませんでした。',
      },
      Transient: {
        General: '',
        MailboxFull: '受信容量が不足しています。',
        MessageTooLarge: 'メッセージ内容が長すぎます。',
        ContentRejected: 'メッセージ内容が適切ではありません。',
        AttachmentRejected: '添付ファイルが承認されませんでした。',
      },
    },

    videoBackgroundUpload: {
      header: '組織の動画用背景画像',
      description:
        '組織のユーザーが録画する動画の背景として使用できる画像です。',
      add: '動画の背景画像を追加',
      info: '推奨される画像サイズは、720 x 480 ピクセルです。',
    },
  },

  page: {
    account: {
      title: 'アカウント設定',
      details: 'アカウント詳細',
      name: 'アカウント名',
      save: '保存',
      saved: 'アカウント情報が保存されました。',
      signature: '署名',
      permissions: '許可権限',
      calendar: {
        label: 'Calendar',
        notAuthorized: 'Authorize your calendar here',
        authorized: 'Edit your calendar authorization',
        revokeError: 'We were unable to unlink your calendar. Please try again later and if the problem persists please contact our support.',
        revokeSuccess: 'Successfully unlinked your calendar',
      },
      password: 'パスワード',
      statistics: 'Statistics',
      organization: '企業名',
    },

    actionBar: {
      selection: '選択済み',
    },

    organisationProfile: {
      title: '企業プロフィール',
      details: '企業プロフィール設定',
      brandingHeader: '組織のブランディング',
      name: '企業名',
      owner: 'アカウント保持者',
      customReplyToSubtitle:
        'この欄には送信者名とインタビュー招待状の返信アドレスの編集が可能です。空欄にした場合、招待状を送信したユーザーの名前とメールアドレスが使用されます。',
      customReplyToEmail: 'インタビュー招待状の返信メール',
      customReplyToName: 'インタビュー招待状の送信者名',
      senderInfoDisabled:
        '所属組織のビデオインタビューが無効になっているため、インタビュー招待状の送信者情報を更新できません。',
      slug: 'キャリアサイトURL',
      slugUnavailable: 'このURLは既に使われています。',
      slogan: 'キャリアサイトキャッチコピー',
      language: 'キャリアサイト言語',
      languagePlaceholder: '選択',
      rss: 'RSSフィード',
      type: 'アカウントタイプ',
      save: '保存',
      saved: '企業情報が保存されました。',
      reset: '初期設定に戻す',
      types: {
        free: {
          title: 'Free',
          description: 'Benefits: Free\n1ユーザー\n1職種分の公開型募集職種ページ',
        },
        basic: {
          title: 'Basic',
          description: 'Benefits: Free\n無制限の公開型募集職種ページ\nビデオ面接',
        },
        team: {
          title: 'Team',
          description: 'Benefits:  チーム\n無制限の公開型募集職種ページ\nビデオ面接\n応募者プレゼンテーション',
        },
      },
      companyAdminUsers: '会社の管理ユーザー',
      cancel: 'キャンセル',
      confirmLeave: '変更を保存していません。本当に中止しますか?',
      error: {
        required: '*マークが付いた項目は必須入力です。',
      },
      emailBrandingHeader: 'Eメールブランド',
      emailBrandingDescription: '候補者に送るEメールの色をカスタマイズします。',
    },

    organisationCompetencies: {
      title: '組織の適格性',
      description: 'こちらから組織の適格性を編集、追加、削除できます。こうした項目は、この会社が設置する新しい役職に適したコンピテンシーの初期設定項目となります。それぞれの役職で挙げられた各候補者についてのコンピテンシーは、「コンピテンシー・適合度」欄で確認できます。',
    },

    organisationStages: {
      title: '組織の採用ステップ',
      description: 'ここで組織の採用ステップの編集、追加、削除、並び替えができます。これらは、今後新たな職種が設けられた際に、その職種に適用する採用ステップの初期設定となります。',
    },

    organisationEmailTemplates: {
      preview:
        'メールをプレビューする（プレビューに、最終的なメールの書式がすべてあるわけではありません',
      preview2:
        'Eメールテンプレートの色は、企業のブランド設定ページでカスタマイズできます。',
      timedInterviewPreviewInfo:
        '時間通りに作動するビデオインタビュー用メッセージには、サポートへの連絡に関する箇所は含まれていません.',
      templateTypes: {
        interviewInvite: 'ビデオインタビューへのご招待',
        timedInterviewInvite: '時間指定のビデオインタビューへのご招待s',
        interviewCompleted:
          'インタビューの終了 ／ 候補者に対するお礼のメッセージ',
        applicationCompleted: '求人広告の応募は締め切らせていただきました／求人広告応募者へのお礼メッセージ',
      },
      subHeaders: {
        jobAdLabel: '求人広告',
        interviewLabel: 'ビデオ面接',
      },
      deleteTemplate: 'テンプレートを削除する',
      confirmation: templateName =>
        `組織のEメールテンプレートからテンプレート"${templateName}" を削除しますか？`,
      deleteSuccess:
        '組織のEメールテンプレートからテンプレートが削除されました。',
      emailTemplateInfo: '現在のところ、1言語につき保存できるテンプレートは1つのみです。',
      templateError: 'Template with same name or language already exists.',
    },

    application: {
      back: '応募者リストに戻る',
      delete: '応募データを削除する',
      deleted: '応募データを削除しました。',
      interviewClosed: '面接は終了しています。',
      resendInvitation: '応募者へ案内を再送する',
      changeStage: 'ステップを移動する',
      commentsAndClassifications: 'コメント・分類',
      openingTitle: title => `ビデオ面接 - ${title}`,
      yourRatingText: 'あなたの評価:',
      competencesAndCompatibility: 'コンピテンシー・適合度',
      duplicateCompetency: '既に存在するコンピテンシーです。',
      competencyNotFound: 'コンピテンシーが見つかりません。',
      confirmDelete: 'この応募データを本当に削除してよろしいですか？',
      lastSeen: time => `最終閲覧 ${time}.`,
      stageChanged: 'Great!',
      reopenProcessConfirm: 'こちらの候補者を「辞退者」リストから外し、採用プロセスに戻しますか？ この操作の承認後、候補者は完了していない面接の質問に答えることができるようになります。',
      withdrawConfirm: 'この候補者を採用プロセスから除外しますか？ 除外した場合、その候補者は招待した一切の面接の質問に回答できなくなります。',
      stageChangedInfo: stage => `早速この応募者が "${stage}" に移動されました。ご本人にも伝えてあげましょう！ \n\n Eメールやビデオメッセージを送信しましょう`,
      close: '終了',
      changestageTooltip: '現時点における候補者の採用ステージを確認できます。希望するステージをクリックして、手動で採用ステージを設定できます。ステージの設定は候補者に通知されません。',
      commentsTooltip: '候補者の応募に対するコメントを同僚に見せることが出来ます。候補者は、このコメントにアクセスできません。',
      competencesTooltip: '必要能力の追加・評価ができます。同僚は追加した必要能力を確認したり、新たに作成したりできます。候補者はこの情報を見れません。',
      actionlogTooltip: 'コメント、ステージの変更、メッセージ、その他アクティビティがここに表示されます。この情報は候補者には表示されません。',
      stage: {
        new: '新規',
        hired: '採用',
        proceed: '進行中',
        personalinterview: '対面型面接',
        withdrawn: '辞退',
        scheduledinterview: '予定済の面接',
        rejected: '不合格',
        videointerviewed: 'ビデオ面接済',
      },
      state: {
        invited: '案内済',
        visited: '閲覧有',
        incomplete: '未完了',
        completed: '完了',
      },
      notVisited: 'まだ面接画面を訪れていません。',
    },

    billing: {
      title: '請求情報',
      nextPayment: (nextBillingPeriodAmount, nextBillingDate) => `次回のご請求は ${nextBillingPeriodAmount} EUR です。（処理日程: ${nextBillingDate}）`,
      status: 'ステータス',
      singleHire: 'Recright Single',
      billingOverview: 'ご請求概要',
      payment: 'お支払い',
      paymentHistory: 'お支払い履歴',
      updateDetails: '請求情報詳細の更新',
      billingStatus: {
        pending: '保留中',
        active: '有効',
        pastdue: '延滞',
        expired: '期限切れ',
        canceled: 'キャンセル済',
      },
      noContractsFound: 'No contracts found. Please contact customer support.',
      monthlyPrice: 'Monthly Price:',
      productName: 'Product Name:',
      products: 'Products',
      nextInvoiceDate: 'Next Invoice Date:',
      monthlyValue: 'Monthly Value:',
      invoiceFrequency: 'Invoice Frequency:',
      months: '(months)',
      nextInvoiceSum: 'Next Invoice Sum:',
      contractStatus: 'Contract Status:',
      contractStartDate: 'Contract Start Date:',
      contractEndDate: 'Contract End Date:',
      termOfNotice: 'Term of Notice:',
      contract: 'Contract',
    },

    candidate: {
      actionLog: '活動履歴',
      back: '応募者一覧へ戻る',
      delete: '応募データを削除する',
      deleted: '応募データを削除しました',
      interviewClosed: '面接は終了しています。再招待は送信しませんでした。',
      resendInvitation: '応募者へ案内を再送する',
      changeStage: 'ステップを移動する',
      introducedTo: '右記の方へ紹介しました:',
      yourRatingText: 'あなたの評価:',
      competencesAndCompatibility: 'コンピテンシー・適合度',
      duplicateCompetency: 'C既に存在するコンピテンシーです。',
      competencyNotFound: 'コンピテンシーが見つかりません。',
      confirmDelete: 'この応募データを本当に削除してよろしいですか？',
      stageChanged: 'Great!',
      stageChangedInfo: stage => `早速この応募者が "${stage}" に移動されました。ご本人にも伝えてあげましょう！ \n\n Eメールやビデオメッセージを送信しましょう。`,
      close: '終了',
      hideStages: 'ステップを隠す',
      showStages: 'ステップを表示する',
      resetQuestionResponseSuccess: '志望者の回答は削除されました',
      stage: {
        new: '新規',
        hired: '採用',
        proceed: '進行中',
        personalinterview: '対面型面接',
        withdrawn: '辞退',
        scheduledinterview: '予定済の面接',
        rejected: 'Rejected',
        videointerviewed: 'ビデオ面接済',
      },
    },

    dashboard: {
      upcomingLiveInterviews: 'ライブ面接',
      showAllLiveInterviews: '全てのライブ面接を表示する',
      createNewLiveInterview: 'ライブ面接を新規作成する',
      welcome: name => `ようこそ, ${name}さん!`,
      liveCard: {
        startTime: '開始時間',
        interviewers: '面接官',
        candidates: '応募者',
      },
    },

    interviewEdit: {
      title: '面接タイトルを入力してください。',
      titleLabel: 'インタビューのタイトル',
      location: '勤務地',
      publishTimePlaceholder: '公開日',
      publishTimeTooltip: '面接の公開日を設定します。日付はいつでも変更できます。',
      endTime: '公開期限',
      endTimeTooltip: '応募受付の締切日を設定する。',
      timezone: 'タイムゾーン',
      isNotPastDate: '過去の日程です。',
      interviewIsClosed: '現在は面接がクローズになっています。',
      interviewIsClosedLink: 'オープンにする',
      edit: {
        details: '面接の修正',
        status: '面接ステータスの変更',
        team: '採用チームの修正',
      },
      questions: '面接設問',
      answerable: '回答可能な設問です。',
      questionsDescription: '面接対象者が回答依頼をされた設問です。',
      questionsNotEditable: '面接の招待をしたあとに、質問内容を編集することはできません。',
      saved: '面接が保存されました。',
      deleted: '面接が削除されました。',
      delete: '面接削除',
      cancel: 'キャンセル',
      save: '保存',
      language: '言語',
      languagePlaceholder: '選択',
      confirmLeave: '変更が保存されていません。本当にページを離れますか？',
      OnboardingHeadImageSize: 'ヘッドバナー画像の推奨サイズは1440px*320px以上です。',
      takeLimitLabel: '撮影回数',
      answerTimeLabel: '回答時間',
      preparationTimeLabel: '準備時間',
      confirmHeader: 'この面接を消去してもいいですか?',
      integratedConfirmContent: 'この面接は、ほかのシステムと統合されているため、消去することにより不具合が生じる場合があります。。',
    },

    interview: {
      endTime: date => (date ? `回答期限: ${date}` : ''),
      edit: '面接を修正する',
      copy: '面接を複製する',
      editInvitation: '案内メッセージを修正する',
      editTeam: '採用チームを修正する',
      editMenu: '修正',
      questions: '面接設問',
      changeStatus: '面接ステータスの変更',
      publishSettings: '公開型の設定',
      invite: '応募者を招待する',
      showCandidates: '応募者を表示する',
      oneError: ' 組み込み型面接は１つの設問しか設定できません。',
      copySuccess: '面接が複製されました。',
      editIntroduceBatches: '紹介情報を編集する',
      editEmailSettings: 'Eメール設定を編集する',
    },

    interviews: {
      allInterviews: '全てのビデオ面接',
      createNewVideoInterview: 'ビデオ面接の新規作成',
      filter: '面接の検索',
      invites: '案内済',
      responses: '応募',
      sort: {
        title: 'タイトル',
        endTime: '終了日',
        publishTime: '公開期日',
        createdAt: '作成日',
        updatedAt: '最終更新日',
        answeredCount: '応募数',
      },
    },

    interviewCandidates: {
      preview: 'Anteprima',
      endTime: date => (date ? `回答期限: ${date}` : ''),
      publicTitle: '公開型面接',
      embedTitle: '埋め込み型面接',
      placeholder: {
        first: '応募者が見つかりません。',
        second: 'ビデオ面接を公開型でもご利用いただけます。',
        third: 'これにより、興味を持った全ての方が面接画面を閲覧可能となり、応募することができます。',
        fourth: '上記タイトルバーからワンクリックで実行可能なことを心に留めておいてください。',
      },
      title: '全ての応募者',
      sort: {
        default: 'デフォルト',
        updatedAt: '最終更新',
        name: 'お名前',
        rating: '評価',
        createdAt: '作成日',
      },
      sendMessage: 'メッセージを送る',
      changeStage: 'ステップを移動する',
      introduce: '紹介する',
      filter: '応募者を検索する',
      hideFilters: 'フィルターを非表示にする',
      showFilters: 'フィルターを表示する',
      emailSent: 'Eメールが送信されました。',
      interviewClosedError: '終了したビデオ面接を応募者に再案内することはできません。',
      excel: '全応募者データのエクスポート',
      reInviteSent: candidates => `${candidates} 件に再案内を送りました。`,
    },

    jobAdEdit: {
      preview: 'プレビュー',
      confirm: 'この募集職種を本当に追加されますか？',
      deleteHeader: 'この募集職種を本当に削除されますか？',
      deleteContent: '募集職種の削除により、関連するビデオ面接データも消去されます:',
      titlePlaceholder: '職種名',
      locationPlaceholder: '勤務地',
      endTimePlaceholder: '公開期限',
      endTimeTooltip: '応募受付の締切日を設定する。',
      isNotPastDate: '過去の日程です',
      publishTimePlaceholder: '公開日',
      publishTimeTooltip: '求人広告の公開日を設定する。公開日は何時でも変更できます。',
      timezone: 'タイムゾーン',
      language: '言語',
      languagePlaceholder: '選択',
      description: '募集要項',
      saved: '募集職種を保存しました。',
      deleted: '募集職種を削除しました。',
      descriptionPlaceholder: 'こちらに募集要項を記入してください。 \n\n上部のツールを活用し、表記をリッチ化していただけます。',
      createInviteOnly: 'Create invite only video interview',
      delete: '募集職種の削除',
      cancel: 'キャンセル',
      save: '保存',
      confirmLeave: '変更点が保存されていません。本当にページを離れますか？',
      singleHireEndError: 'Recright Singleは60日間までしかご利用いただけません。',
      OnboardingHeadImageSize: 'ヘッドバナー画像の推奨サイズは1440px*320px以上です。',
    },

    jobAdApplications: {
      endTime: date => (date ? `, 締切日: ${date}` : ''),
      title: '全ての応募データ',
      sort: {
        updatedAt: '最終更新',
        name: 'お名前',
        rating: '評価',
        createdAt: '作成日',
      },
      add: '応募者の新規登録',
      inviteToInterview: '面接を案内する',
      sendMessage: 'メッセージを送る',
      changeStage: 'ステップを移動する',
      introduce: '応募者を紹介する',
      editIntroduceBatches: '紹介情報を編集する',
      filter: '応募データを検索する',
      hideFilters: 'フィルターを非表示にする',
      showFilters: 'フィルターを表示する',
      addInterviewConfirm: jobAd => `右記募集職種に紐づいたビデオ面接を新規作成しますか？:  "${jobAd}" ?`,
    },

    adminJobAdApplication: {
      name: 'お名前',
      email: 'Eメール',
      phone: '電話番号',
      city: '居住都市',
      back: '戻る',
      continue: '続ける',
      submit: '追加',
      namePlaceholder: ' 名前',
      emailPlaceholder: 'Eメール',
      cityPlaceholder: '居住都市',
      links: 'LinkedInプロフィール等のリンクを追加する',
      legendBasicInfo: '基本情報',
      legendLinks: '参照リンク',
      legendAttachments: '添付ファイル',
      legendAdditionalFields: 'Additional information',
      coverLetter: 'PRメッセージ・カバーレター',
      attachments: '添付ファイル',
      introduction: '簡単な自己紹介文をご記入ください。',
      readyInfo: 'ありがとうございます。候補者をこの役職に追加しました。',
      close: '閉じる',
      excel: '全応募者データのエクスポート',
    },

    jobAdPreview: {
      endTime: date => (date ? `, 締切日： ${date}` : ''),
      exit: 'プレビューを閉じる',
      description: '募集要項',
      video: 'イントロ動画',
      questions: '動画設問',
      apply: 'この職種に応募する',
    },

    jobAd: {
      endTime: date => (date ? `, 締切日： ${date}` : ''),
      changeStatus: '募集職種ステータスの変更',
      edit: '募集職種の修正',
      copy: '募集職種の複製',
      editInvitation: '案内メッセージの修正',
      editTeam: '採用チームの修正',
      editMenu: '修正',
      description: '募集要項',
      video: 'イントロ動画',
      questions: '動画設問',
      apply: 'この職種に応募する',
      showApplications: '応募データを表示する',
      publicLink: '公開型募集職種ページ',
      copySuccess: '募集職種の複製が完了しました。',
    },

    jobAds: {
      subscriptionNeeded: 'この募集職種を公開するには有効化するためのお申し込みが必要です。',
      responses: '応募データ',
      createNewJobPosition: '募集職種の新規作成',
      allJobPositions: '全ての募集職種',
      confirmSingleHire: 'ご購入いただいているRecright Singleから１点をこの募集職種に利用します。',
      filter: '募集職種の検索',
      sort: {
        title: 'タイトル',
        publishTime: '公開期日',
        applicationCount: '応募データ',
        endTime: '終了日',
        createdAt: '作成日',
        updatedAt: '最終更新:',
      },
    },

    jobAdSaved: {
      title: '募集職種を保存しました！',
      description: '貴社の募集職種は保存されています。右記が募集職種ページの公開用リンクです:',
      addApplication: '応募フォームへの直接リンク:',
      toDashboard: 'トップページ',
      toJobAd: '募集職種ページに戻る',
    },

    live: {
      title: 'ライブ面接',
      editTitle: 'ライブインタビューの編集',
      startTimeTitle: '面接開始時間',
      startTime: '開始時間',
      interviewers: '面接官',
      candidates: '応募者',
      messageLabel: '招待メッセージ',
      create: '作成',
      save: '変更を保存',
      cancel: 'キャンセル',
      removeLive: 'ライブ面接を消去する',
      cancelLive: 'ライブ面接をキャンセルする',
      comment: 'コメントを残す',
      commentLabel: 'コメント',
      enter: 'ライブ面接に入る',
      edit: '参加者の追加・削除',
      draft: '新規ライブ面接',
      pending: 'Waiting for candidate confirmation',
      scheduledLiveCandidateSubtitle:
        'For the scheduled live interview you can only add one candidate.',
      confirmHeader: 'この面接を消去してもいいですか?',
      inviteFailure: (success, failed) => `${success} 招待を送信しましたが ${failed}失敗しました！`,
      inviteSuccess: success => `${success} 招待を送信しました。`,
      recordingsHeaderWithTitle: title => `ライブインタビュー${title}の録画`,
      recordingsHeader: 'ライブインタビューの録画',
      success: {
        create: '新規ライブ面接を作成しました。',
        delete: 'ライブ面接を消去しました。',
        update: 'ライブ面接を更新しました。',
      },
      placeholders: {
        candidateEmails: '応募者を追加する',
        interviewerEmails: '面接官を追加する',
        emailTitle: '件名',
        emailMessage: '本文',
        emailName: 'お名前',
      },
    },

    lives: {
      allLives: '全てのライブ面接',
      createNewLive: 'ライブ面接を新規作成する',
      filter: '応募者から検索する',
      candidates: '応募者',
      sort: {
        title: 'タイトル',
        startTime: '開始時間',
        createdAt: '作成日',
      },
    },

    login: {
      title: 'サービスにログインする',
      register: '登録',
      ldap: 'LDAPインテグレーションでログインする',
      forgot: 'パスワードをお忘れですか？',
      normal: '通常ログイン',
      ssoLogin: 'SSOログイン',
    },

    publicSubscribe: {
      intro: 'ご希望のプランを選択してください。支払い情報をご記入いただけましたらすぐにRecrightビデオ面接ツールのご利用をいただけます。お支払いは安全なBraintreeを通して処理されるので安心です。',
      headline: '申込フォーム',
      header: {
        back: 'Back',
      },
      footer: {
        product: 'Product',
        pricing: 'Pricing',
        resources: 'Resources',
        contact: 'Contact',
        terms: 'User Terms and Conditions',
        privacyPolicy: 'Privacy policy',
        license: 'General Terms of Service',
      },
    },

    publicSubscribeThankYou: {
      title: 'ありがとうございます!',
      existingDescription: '貴社のお申し込み情報を受け付けました。このままRecrightビデオ面接ツールを続けてご利用いただけます。',
      newUserDescription: '貴社のアカウントを作成いたしました。Eメールでパスワード設定のご案内をお送りしましたのでご確認ください。',
    },

    quickInterview: {
      title: 'クイックビデオ設問',
      description: 'あなたのことをスピーディに知るために、質問に簡潔にご回答ください。あなたのお人柄や応募の熱意を表してご回答いただけたら嬉しく思います。',
      requiredNote: 'まだ応募プロセスは完了していません。ご回答の録画を終えることで初めてご応募完了となります。',
      reminderNote: '今すぐに設問への回答を録画することができます。また、後ほどリマインドメールが送信されますので、その際に録画を追加（応募再開）することも可能です。',
    },

    searchResults: {
      title: '検索結果',
      applications: '応募データ',
      candidates: '応募者',
      noApplications: '検索条件に該当する応募データはありません。',
      noCandidates: '検索条件に該当する応募者データはありません。',
      query: query => (query ? `検索クエリー: ${query}` : ''),
      noStage: 'どのステップにも進んでいません。',
      search: '検索',
      itemsPerPage: 'Items per page',
    },

    register: {
      title: '採用担当者向けの設計！',
      leadText: 'Recrightは、人材スカウトや採用担当者向けに開発された、ユーザーフレンドリーな採用専用システムです。募集したい職種の公開、就職応募の受け付け、さらにビデオ面接の開催まで、このシステムを使って一括で実施できます。すでに400社以上の企業に採用されており、求める人材獲得の達成に大きく貢献しています。ぜひ貴社も、このシステムの導入をご検討ください。お申し込みは以下のリンクから。さっそく人材の獲得を始めましょう！',
      email: 'Eメール',
      submit: 'サインアップ',
      alreadyMember: '既にアカウントをお持ちですか?',
      onlyForRecruiters: 'この申込書は、人材スカウトと採用担当者のために作成したものです。',
      login: 'こちらからログイン。',
      registerSuccess: 'Eメールにリンクを送信しましたのでご確認ください。',
      domainError: '会社のメールアドレスでご登録ください。',
      companyExistsMessage: '電子メールで指示をご確認ください。',
    },

    statistics: {
      linkToDetailed: '詳細な統計データを見る',
      linkToSummary: '統計データ概要を見る',
      summaryLeadText: '以下の数字は、選択された期間における募集中の職種の総計です。終了日を設定していない募集職種も含まれています。',
      detailsLeadText: 'このページは、選択期間において何らかの形式で募集が行われた職種のすべてに関する詳細データを記載しています。',
      export: 'Export statistics',
      sort: {
        title: '職種名',
        owner: '所有者',
        createdAt: '作成日',
      },
      exportLimit:
        'Too many results. Please reduce the timeframe to enable excel export.',
      tooManyResults:
        'Too many results. Please reduce the timeframe to get results.',
    },

    welcome: {
      title: 'サインアップ',
    },

    welcomeMulticompany: {
      welcome: companyName => `${companyName} へようこそ`,
      successMessage: companyName =>
        `あなたは組織${companyName}に追加されました！`,
      navigationInfo:
        '右上のナビゲーションバーから、現在の組織を変更できます。',
      login: 'こちらからログイン',
    },

    forgotPassword: {
      title: '新しいパスワードを設定する',
      email: 'Eメール',
      submit: '送信',
      sendEmail: 'Recrightに登録されたEメールアドレスをお送りください。',
      instructions: 'パスワードの変更方法をお送りいたします。',
      success: 'ご提供いただいたEメールアドレスに該当が認められた場合、そのアドレスにパスワード変更方法をお送りしています。',
    },

    changePassword: {
      title: 'パスワードを変更する',
      name: 'お名前',
      email: 'Eメール',
      password: '新しいパスワード',
      confirmPassword: '新しいパスワードの確認',
      submit: 'パスワード変更',
      error: {
        password: {
          isRequired: 'パスワードが必要です ',
          isValidPassword: 'パスワードには、大文字1文字、小文字1文字、数字1文字を含む最低8文字が必要です。',
          passwordsMatch: 'パスワードが正しくありません',
        },
      },
    },

    ssoLogin: {
      title: 'SSOログイン',
      description: '組織の資格情報でログインしてください。',
      info: '外部認証が設定されていません。',
      normalLoginLinkText: '通常のログインをご使用ください。',
      submit: 'ログイン',
    },

    subscribe: {
      title: 'お申し込み',
      submit: '申込',
      creditCard: 'クレジットカード',
      cvv: 'CVV',
      expirationDate: '有効期限',
      vatAdvice: 'VAT IDをご提供いただくと、付加価値税は請求されません。',
      vatId: 'VAT / Tax ID',
      vatHelp: 'VAT IDをお持ちの場合は国別コードを含む国際規格に基づいてご記入ください。',
      includeVat: 'VATを含む',
      firstName: '名',
      lastName: '姓',
      email: 'Eメール',
      company: '企業名',
      street: '住所',
      postalCode: '郵便番号',
      city: '都道府県',
      country: '国',
      emptyCardFields: 'クレジットカード情報をご記入ください。',
      invalidValue: 'ご記入内容が有効ではありません。',
      planNotSelected: 'ご利用プランを選択してください。',
      totalPrice: '合計',
      subscribed: '本当にありがとうございます! お申し込みが完了しました。',
      subscriptionExists: '貴社から既に有効なお申し込みをいただいているようです。ログインの上、申し込み内容を変更してください。',
      agreeTos: '私はRecright ユーザー使用条件を読んだ上で、',
      agreeTosLinkText: '承認します。',
      privacyPolicy: '当社ではお客様のプライバシーを大切にしています。当社の ',
      privacyPolicyLinkText: 'プライバシーポリシー’をお読みになり',
      licenseAgreement: '私は代表を務める組織に代わって、',
      licenseAgreementLinkText: 'Recright一般利用規約を受諾します。',
      newsletter: 'マンスリーニュースレターに登録する',
      neverExpiresDiscount: amount => `無期限ご利用クーポン: ${amount} EUR （クーポンをお持ちの場合）`,
      fixedPeriodDiscount: (amount, cycles) => `期間限定ご利用クーポン: ${amount} EUR （最初の ${cycles} ヶ月間）`,
      errorFromProcessor: error => `支払い処理でエラーが発生しました：${error}`,
    },

    videos: {
      title: 'ビデオライブラリー',
      add: '新規動画を作成する',
      rename: '名称変更',
      remove: '消去',
      yourVideos: 'あなたのビデオ',
      companyVideos: '会社のビデオ',
      sort: {
        createdAt: '作成日',
        title: 'タイトル',
      },

    },

    userManagement: {
      excel: 'すべてのユーザーの保存',
      title: 'ユーザー管理',
      showCompanyDefaultPermissions: 'デフォルトの権限設定を表示',
      activateUserConfirm: 'このユーザーを本当に有効化しますか？',
      deactivateUserConfirm: 'このユーザーを本当に無効化しますか？',
      showActivatedUsers: '有効化されているユーザー',
      showDeactivatedUsers: '無効化されているユーザー',
      confirmCancelEditPermissions: {
        message: '修正を中止しますか？',
        cancel: 'キャンセル',
        confirm: '修正中止',
      },
      unsavedChanges: '変更内容を保存してから終了してください。',
      confirm: '保存',
      permissionsChangesSaved: 'ユーザー権限設定が変更されました!',
      userDeactivated: nameOrEmail => `${nameOrEmail} が無効化されました。`,
      userActivated: nameOrEmail => `${nameOrEmail} が有効化されました。`,
      companyDefaultsSaved: 'デフォルトの権限設定が変更されました!',
      usersAddAdded: success => `${success} ユーザーが追加登録されました。`,
      usersAddExist: exist => ` ${exist} ユーザーが既にRecrightに登録されています。`,
      excel: 'すべてのユーザーの保存',
    },

  },

}
